const toCompetencies = (labels) => labels.map((label, i) => ({ index: i + 1, label }));

export const ENGLISHK_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "auditory",
         label: "Auditory",
         start: 1,
         count: 6,
         mean: 4.17,
         stdDev: 0.99,
         ranges: [[0,3.67,"Beginner"],[3.68,5.16,"Basic"],[5.17,6,"Competent"]]
      },
      {
         key: "orallanguage",
         label: "Oral Language",
         start: 7,
         count: 2,
         mean: 1.44,
         stdDev: 0.42,
         ranges: [[0,1.22,"Beginner"],[1.21,1.86,"Basic"],[1.87,2,"Competent"]]
      },
      {
         key: "alphabetknowledge",
         label: "Alphabet Knowledge",
         start: 9,
         count: 6,
         mean: 3.67,
         stdDev: 1.37,
         ranges: [[0,2.98,"Beginner"],[2.99,5.04,"Basic"],[5.05,6,"Competent"]]
      },
      {
         key: "studyskills",
         label: "Study Skills",
         start: 15,
         count: 2,
         mean: 0.92,
         stdDev: 0.43,
         ranges: [[0,0.7,"Beginner"],[0.71,1.35,"Basic"],[1.36,2,"Competent"]]
      },
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 17,
         count: 14,
         mean: 10.06,
         stdDev: 1.7,
         ranges: [[0,9.2,"Beginner"],[9.21,11.8,"Basic"],[11.81,14,"Competent"]]
      }
   ],
   totalRanges: [[0,16.1,"Beginner"],[16.11,21.2,"Basic"],[21.21,30,"Competent"]],
   totalSummary: {
      count: 30,
      mean: 17.83,
      stdDev: 3.37
   },
   sections: [
      {
         label: "Auditory",
         start: 1,
         end: 6
      },
      {
         label: "Oral Language",
         start: 7,
         end: 8
      },
      {
         label: "Alphabet Knowledge",
         start: 9,
         end: 14
      },
      {
         label: "Study Skills",
         start: 15,
         end: 16
      },
      {
         label: "Vocabulary",
         start: 17,
         end: 30
      }
   ],
   competencies: toCompetencies([
      "Identify familiar sounds in the environment.",
      "Identify familiar sounds in the environment.",
      "Tell who/what is producing a given sound.",
      "Tell who/what is producing a given sound.",
      "Tell if the sound is loud/soft, high/low.",
      "Tell if the sound is loud/soft, high/low.",
      "Use polite greetings and courteous expressions in appropriate situations 1.1 Good Morning/Afternoon 1.2 Thank You/You’re Welcome 1.3 Excuse Me/I’m Sorry 1.4 Please…./May I…..",
      "Use polite greetings and courteous expressions in appropriate situations 1.1 Good Morning/Afternoon 1.2 Thank You/You’re Welcome 1.3 Excuse Me/I’m Sorry 1.4 Please…./May I…..",
      "Alphabet (mother tongue, orthography).",
      "Alphabet (mother tongue, orthography).",
      "Give the sound of each letter (mother tongue, orthography).",
      "Give the sound of each letter (mother tongue, orthography).",
      "Name the beginning letters of their friends' names, their family members’, and common things they use.",
      "Name the beginning letters of their friends' names, their family members’, and common things they use.",
      "Name the places and the things found in a map of a classroom.",
      "Name the places and the things found in a map of a classroom.",
      "Name common objects/things in the environment (in school, home, and community).",
      "Name common objects/things in the environment (in school, home, and community).",
      "Describe common objects/things in the environment based on color, shape, size, and function/use.",
      "Describe common objects/things in the environment based on color, shape, size, and function/use.",
      "Give the meaning of words presented through real objects, pictures, actions, synonyms and antonyms, and context clues.",
      "Give the meaning of words presented through real objects, pictures, actions, synonyms and antonyms, and context clues.",
      "Name objects that begin with a particular letter of the alphabet.",
      "Name objects that begin with a particular letter of the alphabet.",
      "Give the names of family members, school personnel, and community helpers, and the roles they play/ jobs they do/things they use.",
      "Give the names of family members, school personnel, and community helpers, and the roles they play/ jobs they do/things they use.",
      "Name the places and the things found in the classroom, school and community.",
      "Name the places and the things found in the classroom, school and community.",
      "Give the synonyms and antonyms of given words.",
      "Give the synonyms and antonyms of given words."
   ])
};

export const MATHK_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "sorting",
         label: "Sorting",
         start: 1,
         count: 5,
         mean: 3.89,
         stdDev: 0.32,
         ranges: [[0,3.72,"Beginner"],[3.73,4.21,"Basic"],[4.22,5,"Competent"]]
      },
      {
         key: "counting",
         label: "Counting",
         start: 6,
         count: 8,
         mean: 6.33,
         stdDev: 1.24,
         ranges: [[0,5.7,"Beginner"],[5.71,7.57,"Basic"],[7.58,8,"Competent"]]
      },
      {
         key: "algebra",
         label: "Patterns And Algebra",
         start: 14,
         count: 12,
         mean: 9.28,
         stdDev: 1.49,
         ranges: [[0,8.53,"Beginner"],[8.54,10.8,"Basic"],[10.81,12,"Competent"]]
      },
      {
         key: "measurement",
         label: "Measurement",
         start: 26,
         count: 3,
         mean: 2.5,
         stdDev: 0.51,
         ranges: [[0,2.24,"Beginner"],[2.25,3.01,"Basic"],[3.02,3,"Competent"]]
      },
      {
         key: "measurement",
         label: "Data Analysis",
         start: 29,
         count: 2,
         mean: 2.5,
         stdDev: 0.51,
         ranges: [[0,2.24,"Beginner"],[2.25,3.01,"Basic"],[3.02,3,"Competent"]]
      }
   ],
   totalRanges: [[0,18.9,"Beginner"],[18.91,23.36,"Basic"],[23.37,30,"Competent"]],
   totalSummary: {
      count: 30,
      mean: 20.39,
      stdDev: 2.97
   },
   sections: [
      {
         label: "Sorting",
         start: 1,
         end: 5
      },
      {
         label: "Counting",
         start: 6,
         end: 13
      },
      {
         label: "Patterns And Algebra",
         start: 14,
         end: 25
      },
      {
         label: "Measurement",
         start: 26,
         end: 28
      },
      {
         label: "Data Analysis",
         start: 29,
         end: 30
      }
   ],
   competencies: toCompetencies([
      "Recognize simple shapes in the environment.",
      "Identify two-dimensional shapes.",
      "Identify three dimensional shapes.",
      "Describe objects according to.",
      "Group objects that are alike.",
      "Copy, make and continue patterns.",
      "Count forward and backward from memory up to 10.",
      "Recognize and identify numeral0 to 10.",
      "Read and write numeral 0 to 10.",
      "Match numerals to a set of concrete objects from 0 to 10.",
      "Identify the number that comes before, after or in-between.",
      "Arrange three numbers from least to greatest/ greatest to least.",
      "Match objects/pictures using one-to-one correspondence.",
      "Recognize and identify coins and bills up to PhP20 (pesos and centavos).",
      "Recognize the words “put together,” “add to.” and “in all”, that indicate the act of adding whole numbers.",
      "Recognizes the words “take away,” “less.” and “are left”, that indicate the act of subtracting whole numbers.",
      "Represent the concept of addition by combining elements of two sets using concrete objects.",
      "Represent the concept of subtraction by crossing out/taking away element from a set using concrete objects.",
      "Use manipulative to explore the concept of addition and subtraction with sums and differences between 0 and 10.",
      "Add quantities up to 10 using concrete objects.",
      "Subtract quantities up to 10 using concrete objects.",
      "Match addition and subtraction expressions with concrete representations.",
      "Write addition and subtraction expressions and equation with concrete representations.",
      "Recognize situations that require addition and subtraction.",
      "Compare objects based on their size, length, weight, mass.",
      "Tell the time of day when activities are being done, E.g. morning, afternoon, night time.",
      "Compare time intervals by determining which activities take a longer or shorter time.",
      "Collect data on one variable (e.g. sex or boys and girls) through observation and asking a question.",
      "Organize data into pictographs.",
      "Interpret pictographs."
   ])
};

export const SCIENCEK_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "livingthings",
         label: "Living Things",
         start: 1,
         count: 8,
         mean: 10.17,
         stdDev: 2.41,
         ranges: [[0,8.96,"Beginner"],[8.97,12.58,"Basic"],[12.59,18,"Competent"]]
      },
      {
         key: "physicalscience",
         label: "Physical Science",
         start: 9,
         count: 14,
         mean: 2.06,
         stdDev: 0.94,
         ranges: [[0,1.58,"Beginner"],[1.59,3,"Basic"],[3.01,4,"Competent"]]
      },
      {
         key: "earthscience",
         label: "Earth Science",
         start: 23,
         count: 4,
         mean: 2.05,
         stdDev: 0.71,
         ranges: [[0,1.69,"Beginner"],[1.7,2.76,"Basic"],[2.77,3,"Competent"]]
      }
   ],
   totalRanges: [[0,18.3,"Beginner"],[18.31,22.5,"Basic"],[22.51,25,"Competent"]],
   totalSummary: {
      count: 26,
      mean: 19.72,
      stdDev: 2.76
   },
   sections: [
      {
         label: "Living Things",
         start: 1,
         end: 8
      },
      {
         label: "Physical Science",
         start: 9,
         end: 22
      },
      {
         label: "Earth Science",
         start: 23,
         end: 26
      }
   ],
   competencies: toCompetencies([
      "Identify one’s basic body parts.",
      "Tell the function of each basic body part.",
      "Demonstrate movements using different body parts.",
      "Name the five senses and their corresponding body parts.",
      "Use the senses to observe the environment.",
      "Use the senses to observe and perform simple experiments in classifying objects.",
      "Identify one’s basic needs and ways to care for one’s body.",
      "Practice ways to care for one’s body.",
      "Describe how one grows and changes",
      "Name common animals.",
      "Observe, describe, and examine common animals using their senses.",
      "Group animals according to certain characteristics.",
      "Identify the needs of animals.",
      "Identify ways to care for animals.",
      "Identify and describe how animals can be useful.",
      "Name common plants.",
      "Communicate changes observed.",
      "Group plants according to certain characteristics.",
      "Classify objects according to observable properties like size, color, shape, texture, and weight.",
      "Identify needs of plants and ways to care for plants.",
      "Identify and describe how plants can be useful.",
      "Explores how objects can be moved like pushing, pulling, rising, sinking, blowing.",
      "Identify what we wear and use for each kind of weather.",
      "Identify simple ways of taking care of the environment.",
      "Explore simple cause-and-effect relationships in familiar events and situations."
   ])
};

export const ENGLISH1_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "phonologicalawareness",
         label: "Phonologicalawareness",
         start: 1,
         count: 6,
         mean: 4.36,
         stdDev: 1.58,
         ranges: [[0,3.56,"Beginner"],[3.57,5.94,"Basic"],[5.95,6,"Competent"]]
      },
      {
         key: "orallanguage",
         label: "Orallanguage",
         start: 7,
         count: 2,
         mean: 1.48,
         stdDev: 0.51,
         ranges: [[0,1.22,"Beginner"],[1.23,1.7,"Basic"],[1.71,2,"Competent"]]
      },
      {
         key: "readingcomprehension",
         label: "Readingcomprehension",
         start: 9,
         count: 12,
         mean: 5.12,
         stdDev: 1.69,
         ranges: [[0,4.27,"Beginner"],[4.28,6.81,"Basic"],[6.82,12,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar",
         start: 21,
         count: 6,
         mean: 3.32,
         stdDev: 1.44,
         ranges: [[0,2.59,"Beginner"],[2.6,4.76,"Basic"],[4.77,6,"Competent"]]
      },
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 27,
         count: 4,
         mean: 2.76,
         stdDev: 1.13,
         ranges: [[0,2.19,"Beginner"],[2.2,3.89,"Basic"],[3.9,4,"Competent"]]
      }
   ],
   totalRanges: [[0,14.8,"Beginner"],[14.81,21.5,"Basic"],[21.51,30,"Competent"]],
   totalSummary: {
      count: 30,
      mean: 2.76,
      stdDev: 1.13
   },
   sections: [
      {
         label: "Phonologicalawareness",
         start: 1,
         end: 6
      },
      {
         label: "Orallanguage",
         start: 7,
         end: 8
      },
      {
         label: "Readingcomprehension",
         start: 9,
         end: 20
      },
      {
         label: "Grammar",
         start: 21,
         end: 26
      },
      {
         label: "Vocabulary",
         start: 27,
         end: 30
      }
   ],
   competencies: toCompetencies([
      "Recognize rhyming words in nursery rhymes, poems, songs heard.",
      "Recognize rhyming words in nursery rhymes, poems, songs heard.",
      "Give the number of syllables of given words.",
      "Give the number of syllables of given words.",
      "Distinguish rhyming words from non-rhyming words.",
      "Distinguish rhyming words from non-rhyming words.",
      "Give information about stories on when and where it took place.",
      "Give information about stories on when and where it took place.",
      "Note important details pertaining to.",
      "Note important details pertaining to.",
      "Note important details pertaining to.",
      "Give the correct sequence of three events.",
      "Infer the character feelings and traits.",
      "Predict a possible ending of the story read.",
      "Identify cause and/or effect of events.",
      "Identify cause and/or effect of events.",
      "Identify cause and/or effect of events.",
      "Identify the problem and solution.",
      "Identify the problem and solution.",
      "Identify the problem and solution.",
      "Recognize sentences and non-sentences.",
      "Recognize sentences and non-sentences.",
      "Recognize simple sentences.",
      "Recognize simple sentences.",
      "Recognize telling and asking sentences.",
      "Recognize telling and asking sentences.",
      "Use words that are related to self, family, school, community, and concepts such as the names for colors, shapes, and numbers in a sentence.",
      "Use words that are related to self, family, school, community, and concepts such as the names for colors, shapes, and numbers in a sentence.",
      "Use words that are related to self, family, school, community, and concepts such as the names for colors, shapes, and numbers in a sentence.",
      "Use words that are related to self, family, school, community, and concepts such as the names for colors, shapes, and numbers in a sentence."
   ])
};

export const MATH1_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "numbersense",
         label: "Numbersense",
         start: 1,
         count: 32,
         mean: 18.67,
         stdDev: 6.08,
         ranges: [[0,15.7,"Beginner"],[15.71,24.8,"Basic"],[24.81,32,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 33,
         count: 2,
         mean: 0.88,
         stdDev: 0.48,
         ranges: [[0,0.63,"Beginner"],[0.64,1.36,"Basic"],[1.37,2,"Competent"]]
      },
      {
         key: "algebra",
         label: "Algebra",
         start: 35,
         count: 5,
         mean: 1.88,
         stdDev: 0.83,
         ranges: [[0,1.46,"Beginner"],[1.47,2.71,"Basic"],[2.72,5,"Competent"]]
      },
      {
         key: "measurement",
         label: "Measurement",
         start: 40,
         count: 6,
         mean: 2.44,
         stdDev: 1.36,
         ranges: [[0,1.75,"Beginner"],[1.76,3.8,"Basic"],[3.81,6,"Competent"]]
      },
      {
         key: "statistics",
         label: "Statistics",
         start: 46,
         count: 5,
         mean: 1.48,
         stdDev: 0.87,
         ranges: [[0,1.04,"Beginner"],[1.05,2.35,"Basic"],[2.36,5,"Competent"]]
      }
   ],
   totalRanges: [[0,21.1,"Beginner"],[21.11,33.59,"Basic"],[33.6,50,"Competent"]],
   totalSummary: {
      count: 50,
      mean: 25.24,
      stdDev: 8.34
   },
   sections: [
      {
         label: "Numbersense",
         start: 1,
         end: 32
      },
      {
         label: "Geometry",
         start: 33,
         end: 34
      },
      {
         label: "Algebra",
         start: 35,
         end: 39
      },
      {
         label: "Measurement",
         start: 40,
         end: 45
      },
      {
         label: "Statistics",
         start: 46,
         end: 50
      }
   ],
   competencies: toCompetencies([
      "Number Sense: Counts the number of objects in a given set by ones and tens",
      "Identifies the number that is one more or one less from a given number.",
      "Composes and decomposes a given number.",
      "Regroups sets of ones into sets of tens and sets of tens into hundreds using objects.",
      "Compares two sets using the expressions “less than,” “more than,” and “as many as.”",
      "Orders sets from least to greatest and vice versa.",
      "Counts by 2s, 5s and 10s through 100.",
      "Reads and writes numbers up to 100 in symbols and in words.",
      "Gives the place value and value of a digit in one- and two-digit numbers.",
      "Renames numbers into tens and ones.",
      "Compares numbers up to 100 using relation Symbols.",
      "Orders numbers up to 100 in increasing or decreasing order.",
      "Identifies the 1st , 2nd, 3rd, up to 10th object in a given set from a given point of reference.",
      "Recognizes and compares coins and bills up to PhP100 and their notations.",
      "Recognizes and compares coins and bills up to PhP100 and their notations.",
      "Adds two one-digit numbers with sums up to 18 using the order and zero properties of addition.",
      "Adds two one-digit numbers using appropriate mental techniques e.g. adding doubles and/or near-doubles.",
      "Adds three one-digit numbers using the grouping property of addition.",
      "Adds two to three one digit numbers horizontally and vertically.",
      "Adds numbers with sums through 99 without or with Regrouping.",
      "Solves one-step routine and non-routine problems involving addition of whole numbers including money with sums up to 99 using appropriate problem solving strategies.",
      "Illustrates subtraction as “taking away” or “comparing” elements of sets.",
      "Illustrates that addition and subtraction are inverse operations.",
      "Subtracts one- to two-digit numbers with minuends up to 99 without regrouping.",
      "Uses the expanded form to explain subtraction with regrouping.",
      "Solves routine and non-routine problems involving subtraction of whole numbers including money with minuends up to 99 with and without regrouping using appropriate problem solving strategies and tools.",
      "Counts groups of equal quantity using concrete objects up to 50 and writes an equivalent expression.",
      "Separates objects into groups of equal quantity using concrete objects up to 50.",
      "Identifies ½ and ¼ of a whole object.",
      "Identifies ½ and ¼ of a whole object.",
      "Divides the elements of sets into four groups of equal quantities to show fourth.",
      "Visualizes and draws the whole region or set given its ½ and/or ¼.",
      "Identifies, names, and describes the four basic shapes (square, rectangle, triangle and circle) in 2-dimensional (flat/plane) and 3-dimensional (solid) Objects.",
      "Compares and classifies 2-dimensional (flat/plane) and 3-dimensional (solid) figures according to common attributes.",
      "Determines the missing term/s in a given continuous pattern using one attribute (letters/ numbers/events).",
      "Determines the missing term/s in a given repeating pattern using one attribute(letters, numbers, colors, figures, sizes, etc.).",
      "Constructs equivalent number expression using addition and subtraction.",
      "Identifies and creates patterns to compose and decompose using addition.",
      "Finds the missing number in an addition or subtraction sentence using a variety of ways.",
      "Tells the days in a week; months in a year in the right order.",
      "Solves problems involving time (days in a week, months in a year, hour, half hour, and quarter-hour).",
      "Compares objects using comparative words: short, shorter, shortest; long, longer, longest; heavy, heavier, heaviest; light, lighter, lightest.",
      "Estimates and measures length using non- standard units of linear measures.",
      "Estimates and measures mass using non-standard units of mass measure.",
      "Estimates and measures capacity using non-standard unit.",
      "Infers and interprets data presented in a pictograph without scales.",
      "Solves routine and non-routine problems using data presented in pictograph without scales.",
      "Solves routine and non-routine problems using data presented in pictograph without scales.",
      "Tells whether an event is likely or unlikely to happen.",
      "Describe events in real-life situations using the phrases “ likely” or “unlikely to happen”."
   ])
};

export const SCIENCE1_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "matter",
         label: "Matter",
         start: 1,
         count: 2,
         mean: 1.68,
         stdDev: 0.47,
         ranges: [[0,1.44,"Beginner"],[1.45,1.65,"Basic"],[1.66,2,"Competent"]]
      },
      {
         key: "livingthings",
         label: "Living Things",
         start: 3,
         count: 19,
         mean: 10.32,
         stdDev: 2.09,
         ranges: [[0,9.27,"Beginner"],[9.28,12.41,"Basic"],[12.42,19,"Competent"]]
      },
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 22,
         count: 4,
         mean: 2.16,
         stdDev: 0.8,
         ranges: [[0,1.75,"Beginner"],[1.76,2.96,"Basic"],[2.97,4,"Competent"]]
      },
      {
         key: "earthandspace",
         label: "Earth and Space",
         start: 26,
         count: 5,
         mean: 2.6,
         stdDev: 1.15,
         ranges: [[0,2.02,"Beginner"],[2.03,3.75,"Basic"],[3.76,5,"Competent"]]
      }
   ],
   totalRanges: [[0,18.79,"Beginner"],[18.8,21.91,"Basic"],[21.92,30,"Competent"]],
   totalSummary: {
      count: 30,
      mean: 19.76,
      stdDev: 2.12
   },
   sections: [
      {
         label: "Matter",
         start: 1,
         end: 2
      },
      {
         label: "Living Things",
         start: 3,
         end: 21
      },
      {
         label: "Force And Motion",
         start: 22,
         end: 25
      },
      {
         label: "Earth and Space",
         start: 26,
         end: 30
      }
   ],
   competencies: toCompetencies([
      "Describe changes observed (e.g., solid to liquid, liquid to solid, liquid to gas)",
      "Describe changes observed (e.g., solid to liquid, liquid to solid, liquid to gas)",
      "Describe the function of one’s basic body parts",
      "Give the function of each basic body part.",
      "Describe the five senses and their corresponding body parts",
      "Identify the senses organ used to observe the environment",
      "Describe the texture (soft/hard, smooth/rough), taste (salty, sweet, sour) of objects.",
      "Describe the movements of different body parts.",
      "Identify ways to care for one’s body.",
      "Identify the regular habits to take care of one’s body (taking a bath, brushing one’s teeth etc).",
      "Describe observations of growth and changes",
      "Identify animals that live in land and water",
      "Describe the distinct characteristics of animals",
      "Classify animals with backbone and without backbone",
      "Give ways how animals can be useful",
      "Describe the needs of animals",
      "Identify ways to care for animals",
      "Identify plants that live in air, water, and soil.",
      "Classify plants according to their parts",
      "Identify the needs of plants",
      "Give ways how plants can be useful",
      "Classify objects according to observable properties like size, color, shape, texture, and weight)",
      "Classify objects according to observable properties like size, color, shape, texture, and weight)",
      "Identify what makes objects can be move (pushing, pulling, rising, sinking, blowing)",
      "Identify what makes objects can be move (pushing, pulling, rising, sinking, blowing)",
      "Identify the proper clothing for each kind of weather",
      "Identify the proper clothing for each kind of weather",
      "Identify the cause of events and situations in the environment",
      "Give ways of taking care of the environment",
      "Give ways of taking care of the environment"
   ])
};

export const ENGLISH2_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "readingcomprehension",
         label: "Reading Comprehension",
         start: 1,
         count: 13,
         mean: 8.32,
         stdDev: 2.48,
         ranges: [[0,7.07,"Beginner"],[7.08,10.8,"Basic"],[10.81,13,"Competent"]]
      },
      {
         key: "orallanguage",
         label: "Oral Language",
         start: 13,
         count: 2,
         mean: 1.64,
         stdDev: 0.73,
         ranges: [[0,1.27,"Beginner"],[1.28,1.8,"Basic"],[1.81,2,"Competent"]]
      },
      {
         key: "bookandprintknowledge",
         label: "Book And Print Knowledge",
         start: 15,
         count: 2,
         mean: 1.39,
         stdDev: 0.79,
         ranges: [[0,0.99,"Beginner"],[1,1.5,"Basic"],[1.51,2,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar",
         start: 19,
         count: 16,
         mean: 10.75,
         stdDev: 0.97,
         ranges: [[0,10.3,"Beginner"],[10.31,11.72,"Basic"],[11.73,16,"Competent"]]
      },
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 35,
         count: 11,
         mean: 7.82,
         stdDev: 1.96,
         ranges: [[0,6.83,"Beginner"],[6.84,9.78,"Basic"],[9.79,11,"Competent"]]
      }
   ],
   totalRanges: [[0,16.91,"Beginner"],[16.92,25.7,"Basic"],[25.71,45,"Competent"]],
   totalSummary: {
      count: 44,
      mean: 19.82,
      stdDev: 5.84
   },
   sections: [
      {
         label: "Reading Comprehension",
         start: 1,
         end: 13
      },
      {
         label: "Oral Language",
         start: 13,
         end: 14
      },
      {
         label: "Book And Print Knowledge",
         start: 15,
         end: 16
      },
      {
         label: "Grammar",
         start: 19,
         end: 34
      },
      {
         label: "Vocabulary",
         start: 35,
         end: 45
      }
   ],
   competencies: toCompetencies([
      "Note important details pertaining to.",
      "Note important details pertaining to.",
      "Note important details pertaining to.",
      "Give the correct sequence of three events.",
      "Infer the character feelings and traits.",
      "Predict possible ending of a story read.",
      "Identify the speaker in the story or poem.",
      "Identify cause and/or effect of events.",
      "Identify the problem and solution.",
      "Classify/Categorize sounds heard (animals, mechanical, objects, musical instruments, environment, speech).",
      "Distinguish rhyming words from non-rhyming words.",
      "Distinguish rhyming words from non-rhyming words.",
      "Supply words that rhyme with given words.",
      "Use appropriate expressions in common situations (polite expressions, greetings, seeking directions, apologizing, asking help, query and clarification).",
      "Use appropriate expressions in common situations (polite expressions, greetings, seeking directions, apologizing, asking help, query and clarification).",
      "Recognize the common terms in English relating to part of book (e.g. cover, title page, etc.) book orientation.",
      "Recognize the common terms in English relating to part of book (e.g. cover, title page, etc.) book orientation.",
      "Identify letters in English that are not present in Mother Tongue/Filipino and vice-versa.",
      "Grammar Awareness: Recognize sentences and non-sentences.",
      "Grammar Awareness: Recognize simple sentences.",
      "Grammar Awareness: Recognize different kinds of sentences (declarative, interrogative).",
      "Grammar Awareness: Recognize different kinds of sentences (declarative, interrogative).",
      "Grammar Awareness: Recognize nouns in simple sentences.",
      "Grammar Awareness: Recognize nouns in simple sentences.",
      "Grammar Awareness: Recognize nouns in simple sentences.",
      "Grammar Awareness: Recognize the use of a/an + noun.",
      "Grammar Awareness: Recognize common action words in retelling, conversation, etc.",
      "Grammar Awareness: Recognize descriptions of people, objects, things and places (color, shape, size, height, weight, length, distance, etc.).",
      "Use common nouns in simple sentences.",
      "Use common nouns in simple sentences.",
      "Use personal pronouns (e.g. I, you, he, she, it, we, they) in dialogues.",
      "Use demonstrative pronouns (this/that, these/ those).",
      "Use the most frequently occurring preposition (e.g. on, over, under, to, from, above, etc.).",
      "Describe people, objects, things and places using simple adjectives (color, shape, size, height, weight, length, distance, etc.).",
      "Vocabulary Development: Identify the English equivalent of words in the Mother Tongue or in Filipino.",
      "Vocabulary Development: Identify the English equivalent of words in the Mother Tongue or in Filipino.",
      "Vocabulary Development: Sort and classify familiar words into basic categories (colors, shapes, foods, etc.).",
      "Determine the meaning of words using clues (Total Physical Response through realia, pictures, body movements, context clues etc.).",
      "Recognize that some words mean the same (synonyms).",
      "Recognize that some words mean the same (synonyms).",
      "Recognize that some words mean the same (synonyms).",
      "Recognize that some words have opposite meaning (antonyms).",
      "Recognize that some words have opposite meaning (antonyms).",
      "Recognize that some words have opposite meaning (antonyms).",
      "Give the meaning of a two syllable word."
   ])
};

export const MATH2_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "numbersense",
         label: "Number Sense",
         start: 1,
         count: 29,
         mean: 13.61,
         stdDev: 4.9,
         ranges: [[0,11.2,"Beginner"],[11.21,18.51,"Basic"],[18.52,29,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 30,
         count: 4,
         mean: 2.18,
         stdDev: 0.98,
         ranges: [[0,1.68,"Beginner"],[1.69,3.16,"Basic"],[3.17,4,"Competent"]]
      },
      {
         key: "algebra",
         label: "Patterns And Algebra",
         start: 34,
         count: 2,
         mean: 1.25,
         stdDev: 0.59,
         ranges: [[0,0.95,"Beginner"],[0.96,1.84,"Basic"],[1.85,2,"Competent"]]
      },
      {
         key: "measurement",
         label: "Measurement",
         start: 36,
         count: 10,
         mean: 4.82,
         stdDev: 1.39,
         ranges: [[0,4.12,"Beginner"],[4.13,6.21,"Basic"],[6.22,10,"Competent"]]
      },
      {
         key: "statistics",
         label: "Statistics And Probability",
         start: 46,
         count: 5,
         mean: 2.79,
         stdDev: 1.37,
         ranges: [[0,2.11,"Beginner"],[2.12,4.16,"Basic"],[4.17,5,"Competent"]]
      }
   ],
   totalRanges: [[0,18.6,"Beginner"],[18.61,27.75,"Basic"],[27.76,50,"Competent"]],
   totalSummary: {
      count: 50,
      mean: 21.64,
      stdDev: 6.11
   },
   sections: [
      {
         label: "Number Sense",
         start: 1,
         end: 29
      },
      {
         label: "Geometry",
         start: 30,
         end: 33
      },
      {
         label: "Patterns And Algebra",
         start: 34,
         end: 35
      },
      {
         label: "Measurement",
         start: 36,
         end: 45
      },
      {
         label: "Statistics And Probability",
         start: 46,
         end: 50
      }
   ],
   competencies: toCompetencies([
      "Gives the place value and finds the value of a digit in three-digit numbers.",
      "Reads and writes numbers up to 1 000 in symbols and in words.",
      "Writes three-digit numbers in expanded form.",
      "Compares numbers up to 1000 using relation symbols.",
      "Orders numbers up to 1000 in increasing or decreasing order.",
      "Identifies the 1st through the 20th with the emphasis on 11th to 20th object in a given set from a given point of reference.",
      "Reads and writes money in symbols and in words through PhP100.",
      "Counts the value of a set of bills or a set of coins through PhP100 (peso-coins only; centavo-coins only; peso-bills only and combined peso-coins and peso-bills).",
      "Compares values of different denominations of coins and paper bills through PhP100 using relation symbols.",
      "Illustrates the properties of addition (commutative, associative, identity) and applies each in appropriate and relevant situations.",
      "Adds 2-digit by 3-digit numbers with sums up to 1000 without and with regrouping.",
      "Solves routine and non-routine problems involving addition of whole numbers including money with sums up to 1000 using appropriate problem solving strategies and tools.",
      "Solves problems involving subtraction of whole numbers including money with minuends up to 1000 using appropriate problem solving strategies and tools.",
      "Performs orders of operations involving addition and subtractions of small numbers.",
      "Solves multi-step routine and non-routine problems involving addition and subtraction of 2- to 3-digit numbers including money using appropriate problem solving strategies and tools.",
      "Illustrates multiplication as repeated addition.",
      "Writes a related equation for each type of multiplication: repeated addition, array, counting by multiples, and equal jumps on the number line.",
      "Illustrates the commutative property of multiplication.",
      "Solves routine and non-routine problems involving multiplication of whole numbers including money using appropriate problem solving strategies and tools.",
      "Solves routine and non-routine problems involving multiplication and addition or subtraction of whole numbers including money using appropriate problem solving strategies & tools.",
      "Represents division as equal sharing, repeated subtraction, equal jumps on the number line and using formation of equal groups of objects.",
      "Illustrates that multiplication and division are inverse operations.",
      "Solves routine and non-routine problems involving division of numbers by 2,3,4,5 and 10 and with any of the other operations of whole numbers including money using appropriate problem solving strategies and tools.",
      "Identifies unit fractions with denominators of 10 and below.",
      "Compares unit fractions using relation symbols.",
      "Arranges unit fractions in increasing or decreasing order.",
      "Identifies other fractions less than one with denominators 10 and below.",
      "Compares similar fractions using relation symbols.",
      "Arranges similar fractions in increasing or decreasing order.",
      "Identifies shapes/figures that show symmetry in a line.",
      "Identifies and draws the line of symmetry in a given symmetrical figure.",
      "Recognizes shapes that can tessellate.",
      "Identifies straight lines and curves, flat and curved surfaces in a 3-dimensional object. This is not reflected in the performance standards.",
      "Determines the missing term/s in a given continuous pattern using two attributes (any two of the following: figures, numbers, colors, sizes, and orientations, etc.).",
      "Finds the missing value in a number sentence involving multiplication or division of whole numbers using 2, 3, 4, 5 and 10 only.",
      "Writes time in minutes including a.m. and p.m. using analog and digital clocks.",
      "Finds the elapsed time in days.",
      "Solves problems involving time (minutes including a.m. and p.m. and elapsed time in days).",
      "Compares length in meters or centimeters.",
      "Solves routine and non-routine problems involving length.",
      "Compares mass in grams or kilograms.",
      "Solves routine and non-routine problems involving mass.",
      "Illustrates area as a measure of how much surface is covered or occupied by a plane figure.",
      "Finds the area of a given figure using square-tile units i.e. number of square-tiles needed.",
      "Solves routine and non-routine problems involving any figure using square tiles.",
      "Sorts, classifies, and organizes data in tabular form and presents this into a pictograph without and with scales.",
      "Infers and interprets data presented in a pictograph without and with scales.",
      "Solves routine and non-routine problems using data presented in a pictograph without and with scales.",
      "Solves routine and non-routine problems using data presented in a pictograph without and with scales.",
      "Solves routine and non-routine problems using data presented in a pictograph without and with scales."
   ])
};

export const SCIENCE2_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "matter",
         label: "Matter",
         start: 1,
         count: 7,
         mean: 3.4,
         stdDev: 0.6,
         ranges: [[0,3.09,"Beginner"],[3.1,4,"Basic"],[4.01,7,"Competent"]]
      },
      {
         key: "livingthings",
         label: "Living Things",
         start: 8,
         count: 19,
         mean: 9.3,
         stdDev: 2.58,
         ranges: [[0,8,"Beginner"],[8.01,11.88,"Basic"],[11.89,19,"Competent"]]
      },
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 27,
         count: 7,
         mean: 4.75,
         stdDev: 1.21,
         ranges: [[0,4.14,"Beginner"],[4.15,5.96,"Basic"],[5.97,7,"Competent"]]
      },
      {
         key: "earthandspace",
         label: "Earth and Space",
         start: 34,
         count: 7,
         mean: 4.1,
         stdDev: 1.07,
         ranges: [[0,3.56,"Beginner"],[3.57,5.17,"Basic"],[5.18,7,"Competent"]]
      }
   ],
   totalRanges: [[0,20.11,"Beginner"],[20.12,24.5,"Basic"],[24.51,40,"Competent"]],
   totalSummary: {
      count: 40,
      mean: 21.55,
      stdDev: 2.98
   },
   sections: [
      {
         label: "Matter",
         start: 1,
         end: 7
      },
      {
         label: "Living Things",
         start: 8,
         end: 26
      },
      {
         label: "Force And Motion",
         start: 27,
         end: 33
      },
      {
         label: "Earth and Space",
         start: 34,
         end: 40
      }
   ],
   competencies: toCompetencies([
      "Identify different objects based on their characteristics (e. g. Shape, Weight, Volume, Ease of flow).",
      "Identify if the object is solid, liquid or gas.",
      "Identify if the object is solid, liquid or gas.",
      "Give ways on the proper use and handling solid, liquid and gas found at home and in school.",
      "Give ways on the proper use and handling solid, liquid and gas found at home and in school.",
      "Determine changes in materials based on the effect of temperature: (Solid to liquid, Liquid to solid, Liquid to gas, Solid to gas).",
      "Identify different objects based on their characteristics (e.g. Shape, Weight, Volume, Ease of flow).",
      "Determine the parts and functions of the sense organs of the human body.",
      "Give healthful habits to protect the sense organs.",
      "Describe the place where animals live.",
      "Give the parts and functions of animals.",
      "Give the parts and functions of animals.",
      "Identify animals according to their body parts.",
      "Give the importance of animals to humans.",
      "Give ways to take care of animals.",
      "Identify the parts of plants.",
      "Give different uses of plants to humans.",
      "Describe ways to take care of plants.",
      "Describe ways to take care of plants.",
      "Characterize living and nonliving things.",
      "Describe how plants grow.",
      "Identify observable characteristics that are passed on from parents to offspring (e.g., humans, animals, plants).",
      "Identify the basic needs of humans.",
      "Identify the basic needs of humans.",
      "Give examples how living things depend on the environment to meet their basic needs.",
      "Give ways to protect and conserve the environment.",
      "Give the position of a person or an object in relation to a reference point such as chair, door, another person.",
      "Determine things that can make objects move such as people, water, wind, magnets.",
      "Characterize the movements of objects such as fast/slow, forward/backward, stretching/compressing.",
      "Give sources of light and sound, heat and electricity.",
      "Give sources of light and sound, heat and electricity.",
      "Identify uses of light, sound, heat and electricity.",
      "Identify uses of light, sound, heat and electricity.",
      "Describe the things found in the surroundings.",
      "Give the importance of surroundings to people and other living things.",
      "Determine the changes in the weather over a period of time.",
      "Determine the changes in the weather over a period of time.",
      "Describe how different types of weather affect activities of humans.",
      "Provide safety and precautionary measures in different types of weather.",
      "Provide safety and precautionary measures in different types of weather."
   ])
};

export const ENGLISH3_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "readingcomprehension",
         label: "Reading Comprehension",
         start: 1,
         count: 9,
         mean: 6,
         stdDev: 1.75,
         ranges: [[0,5.12,"Beginner"],[5.13,7.75,"Basic"],[7.76,9,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar",
         start: 10,
         count: 24,
         mean: 17.5,
         stdDev: 4.91,
         ranges: [[0,15,"Beginner"],[15.1,22.41,"Basic"],[22.42,24,"Competent"]]
      },
      {
         key: "phonologicalawareness",
         label: "Phonological Awareness",
         start: 34,
         count: 3,
         mean: 1.63,
         stdDev: 1.02,
         ranges: [[0,1.11,"Beginner"],[1.12,2.65,"Basic"],[2.66,3,"Competent"]]
      },
      {
         key: "spelling",
         label: "Spelling",
         start: 37,
         count: 5,
         mean: 6.06,
         stdDev: 1.69,
         ranges: [[0,2.02,"Beginner"],[2.03,4.59,"Basic"],[4.6,5,"Competent"]]
      },
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 42,
         count: 9,
         mean: 6.06,
         stdDev: 1.69,
         ranges: [[0,5.21,"Beginner"],[5.22,7.75,"Basic"],[7.76,9,"Competent"]]
      }
   ],
   totalRanges: [[0,29.4,"Beginner"],[29.5,41.9,"Basic"],[41.1,50,"Competent"]],
   totalSummary: {
      count: 50,
      mean: 34.06,
      stdDev: 8.64
   },
   sections: [
      {
         label: "Reading Comprehension",
         start: 1,
         end: 9
      },
      {
         label: "Grammar",
         start: 10,
         end: 33
      },
      {
         label: "Phonological Awareness",
         start: 34,
         end: 36
      },
      {
         label: "Spelling",
         start: 37,
         end: 41
      },
      {
         label: "Vocabulary",
         start: 42,
         end: 50
      }
   ],
   competencies: toCompetencies([
      "Note details regarding character, setting and plot.",
      "Note details regarding character, setting and plot.",
      "Sequence 3 events.",
      "Distinguish fact from opinion.",
      "Distinguish fact from opinion.",
      "Distinguish fact from opinion.",
      "Identify cause and effect.",
      "Identify cause and effect.",
      "Identify cause and effect.",
      "Distinguish sentences from non-sentences.",
      "Declarative from an interrogative sentence.",
      "Declarative from an interrogative sentence.",
      "Use proper punctuation for declarative and interrogative sentences.",
      "Use proper punctuation for declarative and interrogative sentences.",
      "Identify an exclamatory sentence.",
      "Identify an imperative sentence",
      "Use nouns (e.g. people, animals, places,, things events) in simple sentences.",
      "Use common and proper nouns.",
      "Use plural form of regular nouns by adding /s/ or /es/ (e.g., dog, dogs; wish, wishes).",
      "Use plural from of frequently occurring irregular nouns (e.g. children,",
      "Use the be-verbs (am, is, are was, were) correctly in sentences.",
      "Identify and use action words in simple sentences.",
      "Form and use the past tense of frequently occurring regular verbs (walk – walked,",
      "Use verbs in simple present tense.",
      "Use verbs in simple future tense.",
      "Use demonstrative pronouns (this,/that, these/those).",
      "Use personal pronouns (e.g. I, you, he, she, it, we, they).",
      "Commonly used possessive pronouns.",
      "Use descriptive adjectives.",
      "Use the most frequently occurring prepositions (e.g. towards, beside,, into, etc.).",
      "Give the synonyms and antonyms of common adjectives.",
      "Use the degrees of adjectives in making comparisons (positive, comparative, superlative).",
      "Recognize adverbs of manner.",
      "Identify sounds and count syllables in words.",
      "Identify words with long a sound (long and short vowel sounds).",
      "Identify words with digraphs.",
      "Spell one- to- two syllable words with consonant blends (e.g. pl, tr).",
      "Spell one- to- two syllable words with consonant blends (e.g. pl, tr).",
      "Use capitalization rules in word and sentence level (e.g. proper and common nouns, beginning words in sentences).",
      "Use capitalization rules in word and sentence level (e.g. proper and common nouns, beginning words in sentences).",
      "Use capitalization rules in word and sentence level (e.g. proper and common nouns, beginning words in sentences).",
      "Classify common words into conceptual categories (e.g. animals, foods, toys).",
      "Recognize some words represented by common abbreviations (e.g. Mr. Ave., Oct.).",
      "Recognize some words represented by common abbreviations (e.g. Mr. Ave., Oct.).",
      "Recognize some words represented by common abbreviations (e.g. Mr. Ave., Oct.).",
      "Give the synonyms and antonyms of some words.",
      "Give the synonyms and antonyms of some words.",
      "Give the synonyms and antonyms of some words.",
      "Determine what words mean based on how they are used in a sentence.",
      "Determine what words mean based on how they are used in a sentence."
   ])
};

export const MATH3_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "numbersense",
         label: "Number Sense",
         start: 1,
         count: 26,
         mean: 11.94,
         stdDev: 4.33,
         ranges: [[0,9.77,"Beginner"],[9.78,16.3,"Basic"],[16.4,26,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 27,
         count: 4,
         mean: 1.75,
         stdDev: 1.13,
         ranges: [[0,1.18,"Beginner"],[1.19,2.88,"Basic"],[2.89,4,"Competent"]]
      },
      {
         key: "patternsandalgebra",
         label: "Patterns And Algebra",
         start: 31,
         count: 2,
         mean: 1.25,
         stdDev: 0.45,
         ranges: [[0,1.02,"Beginner"],[1.03,1.7,"Basic"],[1.71,2,"Competent"]]
      },
      {
         key: "measurement",
         label: "Measurement",
         start: 33,
         count: 5,
         mean: 1.06,
         stdDev: 0.85,
         ranges: [[0,0.62,"Beginner"],[0.63,1.91,"Basic"],[1.92,5,"Competent"]]
      },
      {
         key: "statisticsandprobability",
         label: "Statistics And Probability",
         start: 38,
         count: 3,
         mean: 1.44,
         stdDev: 0.81,
         ranges: [[0,1.03,"Beginner"],[1.04,2.25,"Basic"],[2.26,3,"Competent"]]
      }
   ],
   totalRanges: [[0,11.61,"Beginner"],[11.62,20.21,"Basic"],[20.22,40,"Competent"]],
   totalSummary: {
      count: 40,
      mean: 14.44,
      stdDev: 5.76
   },
   sections: [
      {
         label: "Number Sense",
         start: 1,
         end: 26
      },
      {
         label: "Geometry",
         start: 27,
         end: 30
      },
      {
         label: "Patterns And Algebra",
         start: 31,
         end: 32
      },
      {
         label: "Measurement",
         start: 33,
         end: 37
      },
      {
         label: "Statistics And Probability",
         start: 38,
         end: 40
      }
   ],
   competencies: toCompetencies([
      "Gives the place value and value of a digit in 4- to 5-digit numbers.",
      "Rounds numbers to the nearest ten, hundred and thousand.",
      "Compares numbers up to 10 000 using relation symbols.",
      "Orders 4- to 5-digit numbers in increasing or decreasing order.",
      "Reads and writes money in symbols and in words through PhP1 000 in pesos and centavos.",
      "Compares values of the different denominations of coins and bills through PhP1 000 using relation symbols.",
      "Adds 3- to 4-digit numbers up to three addends with sums up to 10 000 without and with regrouping.",
      "Estimates the sum of 3- to 4-digit addends with reasonable results.",
      "Solves routine and non-routine problems involving addition of whole numbers with sums up to 10 000 including money using appropriate problem solving strategies and tools.",
      "Subtracts 3-to 4-digit numbers from 3- to 4-digit numbers without and with regrouping.",
      "Applies the commutative property of multiplication.",
      "Multiplies 2-digit by 1-digit numbers using the",
      "Multiplies 1- to 2-digit numbers by 1 000.",
      "Multiplies three 1-digit numbers using the associative property of multiplication.",
      "Multiplies 2- to 3-digit numbers by 1-digit numbers without or with regrouping.",
      "Multiplies 2- to 3-digit numbers by multiples of 10 and 100.",
      "Estimates the product of 2- to 3-digit numbers and 1- to 2-digit numbers with reasonable results.",
      "Solves routine and non-routine problems involving multiplication without or with addition and subtraction of whole numbers including money using appropriate problem solving strategies and tools.",
      "Divides 2- to 3-digit numbers by 1- to 2- digit numbers without and with remainder.",
      "Divides 2-3 digit numbers by 10 and 100 without or with remainder.",
      "Estimates the quotient of 2- to 3- digit numbers by 1- to 2- digit numbers.",
      "Solves routine and non-routine problems involving division of 2- to 4-digit numbers by 1- to 2-digit numbers without or with any of the other operations of whole numbers including money using appropriate problem solving strategies and tools.",
      "Identifies odd and even numbers.",
      "Visualizes, represents, and compares dissimilar fractions.",
      "Visualizes, represents, and arranges dissimilar fractions in increasing or decreasing order, visualizes, represents, and arranges dissimilar fractions in increasing or decreasing order.",
      "Visualizes and generates equivalent fractions.",
      "Recognizes and draws parallel, intersecting and perpendicular lines.",
      "Visualizes, identifies and draws congruent line segments.",
      "Identifies and visualizes symmetry in the environment and in design.",
      "Determines the missing term/s in a given combination of continuous and repeating pattern.",
      "Finds the missing value in a number sentence involving multiplication or division of whole numbers.",
      "Visualizes, and represents, and converts time measure from seconds to minutes, minutes to hours, and hours to a day and vice versa.",
      "Visualizes, and represents, and converts time measure 64.1 days to week, month and year and vice versa 64.2 weeks to months and year and vice versa 64.3 months to year and vice versa.",
      "Visualizes, and represents, and solves problems involving conversion of time measure.",
      "Visualizes, and represents, and converts common units of measure from larger to smaller unit and vice versa: meter and centimeter, kilogram and gram, liter and milliliter.",
      "Visualizes, and represents, and solves routine and non-routine problems involving conversions of common units of measure.",
      "Visualizes, and represents, and finds the capacity of a container using milliliter and liter.",
      "Infers and interprets data presented in different kinds of bar graphs (vertical/ horizontal).",
      "Solves routine and non-routine problems using data presented in a single-bar graph.",
      "Tells whether an event is sure, likely, equally likely, unlikely, and impossible to happen."
   ])
};

export const SCIENCE3_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "matter",
         label: "Matter",
         start: 1,
         count: 8,
         mean: 6.19,
         stdDev: 1.17,
         ranges: [[0,5.6,"Beginner"],[5.61,7.36,"Basic"],[7.37,8,"Competent"]]
      },
      {
         key: "livingthings",
         label: "Living Things",
         start: 9,
         count: 32,
         mean: 18.13,
         stdDev: 6.44,
         ranges: [[0,14.11,"Beginner"],[14.12,24.6,"Basic"],[24.61,32,"Competent"]]
      },
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 41,
         count: 10,
         mean: 6.94,
         stdDev: 2.24,
         ranges: [[0,5.81,"Beginner"],[5.82,9.18,"Basic"],[9.19,10,"Competent"]]
      },
      {
         key: "earthandspace",
         label: "Earth and Space",
         start: 51,
         count: 10,
         mean: 5.38,
         stdDev: 1.93,
         ranges: [[0,4.41,"Beginner"],[4.42,7.31,"Basic"],[7.32,10,"Competent"]]
      }
   ],
   totalRanges: [[0,31.81,"Beginner"],[31.82,46.31,"Basic"],[46.32,60,"Competent"]],
   totalSummary: {
      count: 60,
      mean: 36.63,
      stdDev: 9.62
   },
   sections: [
      {
         label: "Matter",
         start: 1,
         end: 8
      },
      {
         label: "Living Things",
         start: 9,
         end: 40
      },
      {
         label: "Force And Motion",
         start: 41,
         end: 50
      },
      {
         label: "Earth and Space",
         start: 51,
         end: 60
      }
   ],
   competencies: toCompetencies([
      "Describe different objects based on their characteristics.",
      "Describe different objects based on their characteristics.",
      "Classify objects and materials as solid, liquid, and gas based on some observable characteristics.",
      "Classify objects and materials as solid, liquid, and gas based on some observable characteristics.",
      "Describe ways on the proper use and handling solid, liquid and gas found at home and in school.",
      "Describe ways on the proper use and handling solid, liquid and gas found at home and in school.",
      "Describe changes in materials based on the effect of temperature.",
      "Describe changes in materials based on the effect of temperature.",
      "Describe the parts and functions of the sense organs of the human body.",
      "Describe the parts and functions of the sense organs of the human body.",
      "Enumerate healthful habits to protect the sense organs.",
      "Enumerate healthful habits to protect the sense organs.",
      "Describe animals in their immediate surroundings.",
      "Describe animals in their immediate surroundings.",
      "Identify the parts and functions of animals.",
      "Identify the parts and functions of animals.",
      "Classify animals according to body parts and use.",
      "Classify animals according to body parts and use.",
      "State the importance of animals to humans.",
      "State the importance of animals to humans.",
      "Describe ways of proper handling of animals.",
      "Describe ways of proper handling of animals.",
      "Describe the parts of different kinds of plants.",
      "Describe the parts of different kinds of plants.",
      "State the importance of plants to humans.",
      "State the importance of plants to humans.",
      "Describe ways of caring and proper handling of plants.",
      "Describe ways of caring and proper handling of plants.",
      "Compare living with nonliving things.",
      "Compare living with nonliving things.",
      "Infer that living things reproduce.",
      "Infer that living things reproduce.",
      "Identify observable characteristics that are passed on from parents to offspring.",
      "Identify observable characteristics that are passed on from parents to offspring.",
      "Identify the basic needs of humans, plants and animals such as air, food, water, and shelter.",
      "Identify the basic needs of humans, plants and animals such as air, food, water, and shelter.",
      "Explain how living things depend on the environment to meet their basic needs.",
      "Explain how living things depend on the environment to meet their basic needs.",
      "Recognize that there is a need to protect and conserve the environment.",
      "Recognize that there is a need to protect and conserve the environment.",
      "Describe the position of a person or an object in relation to a reference point such as chair, door, another person.",
      "Describe the position of a person or an object in relation to a reference point such as chair, door, another person.",
      "Identify things that can make objects move such as people, water, wind, magnets.",
      "Identify things that can make objects move such as people, water, wind, magnets.",
      "Describe the movements of objects such as fast/slow, forward/backward, stretching/compressing.",
      "Describe the movements of objects such as fast/slow, forward/backward, stretching/compressing.",
      "Describe sources of light and sound, heat and electricity.",
      "Describe sources of light and sound, heat and electricity.",
      "Enumerate uses of light, sound, heat and electricity.",
      "Enumerate uses of light, sound, heat and electricity.",
      "Describe the things found in the surroundings.",
      "Describe the things found in the surroundings.",
      "Relate the importance of surroundings to people and other living things.",
      "Relate the importance of surroundings to people and other living things.",
      "Describe the changes in the weather over a period of time.",
      "Describe the changes in the weather over a period of time.",
      "Communicate how different types of weather affect activities in the community.",
      "Communicate how different types of weather affect activities in the community.",
      "Enumerate and practice safety and precautionary measures in dealing with different types of weather.",
      "Enumerate and practice safety and precautionary measures in dealing with different types of weather."
   ])
};

export const ENGLISH4_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 1,
         count: 15,
         mean: 8.69,
         stdDev: 2.18,
         ranges: [[0,7.59,"Beginner"],[7.6,10.9,"Basic"],[10.91,15,"Competent"]]
      },
      {
         key: "readingcomprehension",
         label: "Reading Comprehension",
         start: 16,
         count: 26,
         mean: 12.92,
         stdDev: 3.82,
         ranges: [[0,11,"Beginner"],[11.01,16.7,"Basic"],[16.71,23,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar",
         start: 39,
         count: 22,
         mean: 15.77,
         stdDev: 3.17,
         ranges: [[0,14.2,"Beginner"],[14.21,18.9,"Basic"],[18.91,22,"Competent"]]
      }
   ],
   totalRanges: [[0,26.7,"Beginner"],[26.71,37.6,"Basic"],[37.61,60,"Competent"]],
   totalSummary: {
      count: 63,
      mean: 30.38,
      stdDev: 7.25
   },
   sections: [
      {
         label: "Vocabulary",
         start: 1,
         end: 15
      },
      {
         label: "Reading Comprehension",
         start: 16,
         end: 41
      },
      {
         label: "Grammar",
         start: 39,
         end: 60
      }
   ],
   competencies: toCompetencies([
      "Use context clues (synonyms) to find meaning of unfamiliar words.",
      "Use context clues (synonyms) to find meaning of unfamiliar words.",
      "Use context clues (synonyms) to find meaning of unfamiliar words.",
      "Use context clues (synonyms) to find meaning of unfamiliar words.",
      "Use context clues (definition) to determine the meaning of unfamiliar words.",
      "Identify meanings of unfamiliar words through structural analysis (e.g., compound words and their components: one-word compound [backyard], two-word compound [security guard], hyphenated compound word [sister-in-law]).",
      "Use prefixes and root words as clues to get the meaning of words.",
      "Use prefixes and root words as clues to get the meaning of words.",
      "Use suffixes and root words as clues to get meaning of words.",
      "Get the meaning of words using a dictionary.",
      "Get the meaning of words using a dictionary.",
      "Identify multiple meanings of words.",
      "Identify multiple meanings of words.",
      "Identify different meanings of content specific words. (denotation and connotation).",
      "Identify different meanings of content specific words. (denotation and connotation).",
      "Note significant details in a literary text.",
      "Note significant details in a literary text.",
      "Analyze a story in terms of its setting.",
      "Sequence events in a story or narrative.",
      "Infer feelings and traits of characters in a story read.",
      "Make inferences and draw conclusions based on a literary text.",
      "Make inferences and draw conclusions based on a literary text.",
      "Identify the important story elements such as setting, character, and plot.",
      "Identify the theme of the literary text read.",
      "Predict outcomes of events in the story.",
      "Give possible ending to a story read.",
      "Distinguish reality from fantasy.",
      "Distinguish reality from fantasy.",
      "Distinguish reality from fantasy.",
      "Distinguish reality from fantasy.",
      "Distinguish fact from opinion in a narrative.",
      "Distinguish fact from opinion in a narrative.",
      "Distinguish fact from opinion in a narrative.",
      "Distinguish fact from opinion in a narrative.",
      "Identify various text types according to structure.",
      "Identify various text types according to structure.",
      "Identify various text types according to structure.",
      "Identify various text types according to structure.",
      "Identify and use form of verbs.",
      "Identify and use form of verbs.",
      "Use the present form of verbs that agree with the subject.",
      "Use the present form of verbs that agree with the subject.",
      "Use possessive pronouns that agree in gender with antecedents.",
      "Use correct time expressions to tell an action in the present.",
      "Use the past form of irregular verbs.",
      "Use the past form of regular verbs.",
      "Identify and use adjectives in sentences.",
      "Identify and use words that show degrees of comparison of adjectives in sentences.",
      "Identify and use adverbs of place in sentences.",
      "Use appropriate adverbs of time in sentences.",
      "Use a particular kind of sentence for a specific purpose.",
      "Use a particular kind of sentence for a specific purpose.",
      "Use prepositions in sentences.",
      "Use prepositions in sentences.",
      "Use prepositions in sentences.",
      "Use simple sentence: Simple subject and simple predicate.",
      "Use simple sentence: Simple subject and simple predicate.",
      "Use simple sentence: Simple subject and simple predicate.",
      "Use simple sentence: Compound subject + simple predicate.",
      "Use simple sentence: Simple subject and compound predicate."
   ])
};

export const MATH4_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "numbersense",
         label: "Number Sense",
         start: 1,
         count: 25,
         mean: 11.94,
         stdDev: 4.33,
         ranges: [[0,8.27,"Beginner"],[8.28,16.5,"Basic"],[16.51,25,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 26,
         count: 4,
         mean: 1.75,
         stdDev: 1.13,
         ranges: [[0,0.32,"Beginner"],[0.33,2.11,"Basic"],[2.12,4,"Competent"]]
      },
      {
         key: "algebra",
         label: "Patterns And Algebra",
         start: 30,
         count: 3,
         mean: 1.25,
         stdDev: 0.45,
         ranges: [[0,1.35,"Beginner"],[1.36,2.84,"Basic"],[2.85,3,"Competent"]]
      },
      {
         key: "measurement",
         label: "Measurement",
         start: 33,
         count: 6,
         mean: 1.06,
         stdDev: 0.85,
         ranges: [[0,0.96,"Beginner"],[0.97,3.62,"Basic"],[3.53,6,"Competent"]]
      },
      {
         key: "statistics",
         label: "Statistics And Probability",
         start: 39,
         count: 2,
         mean: 1.44,
         stdDev: 0.81,
         ranges: [[0,0.55,"Beginner"],[0.56,1.44,"Basic"],[1.45,2,"Competent"]]
      }
   ],
   totalRanges: [[0,12.9,"Beginner"],[12.91,23.5,"Basic"],[23.51,40,"Competent"]],
   totalSummary: {
      count: 40,
      mean: 16.45,
      stdDev: 7.09
   },
   sections: [
      {
         label: "Number Sense",
         start: 1,
         end: 25
      },
      {
         label: "Geometry",
         start: 26,
         end: 29
      },
      {
         label: "Patterns And Algebra",
         start: 30,
         end: 32
      },
      {
         label: "Measurement",
         start: 33,
         end: 38
      },
      {
         label: "Statistics And Probability",
         start: 39,
         end: 40
      }
   ],
   competencies: toCompetencies([
      "Gives the place value and value of a digit in 4- to 5-digit numbers.",
      "Rounds numbers to the nearest ten, hundred and thousand.",
      "Compares numbers up to 10 000 using relation symbols.",
      "Orders 4- to 5-digit numbers in increasing or decreasing order.",
      "Reads and writes money in symbols and in words through PhP1 000 in pesos and centavos.",
      "Compares values of the different denominations of coins and bills through PhP1 000 using relation symbols.",
      "Adds 3- to 4-digit numbers up to three addends with sums up to 10 000 without and with regrouping.",
      "Estimates the sum of 3- to 4-digit addends with reasonable results.",
      "Solves routine and non-routine problems involving addition of whole numbers with sums up to 10 000 including money using appropriate problem solving strategies and tools.",
      "Subtracts 3-to 4-digit numbers from 3- to 4-digit numbers without and with regrouping.",
      "Applies the commutative property of multiplication.",
      "Multiplies 2-digit by 1-digit numbers using the",
      "Multiplies 1- to 2-digit numbers by 1 000.",
      "Multiplies three 1-digit numbers using the associative property of multiplication.",
      "Multiplies 2- to 3-digit numbers by 1-digit numbers without or with regrouping.",
      "Multiplies 2- to 3-digit numbers by multiples of 10 and 100.",
      "Estimates the product of 2- to 3-digit numbers and 1- to 2-digit numbers with reasonable results.",
      "Solves routine and non-routine problems involving multiplication without or with addition and subtraction of whole numbers including money using appropriate problem solving strategies and tools.",
      "Divides 2- to 3-digit numbers by 1- to 2- digit numbers without and with remainder.",
      "Divides 2-3 digit numbers by 10 and 100 without or with remainder.",
      "Estimates the quotient of 2- to 3- digit numbers by 1- to 2- digit numbers.",
      "Solves routine and non-routine problems involving division of 2- to 4-digit numbers by 1- to 2-digit numbers without or with any of the other operations of whole numbers including money using appropriate problem solving strategies and tools.",
      "Identifies odd and even numbers.",
      "Visualizes, represents, and compares dissimilar fractions.",
      "Visualizes, represents, and arranges dissimilar fractions in increasing or decreasing order, visualizes, represents, and arranges dissimilar fractions in increasing or decreasing order.",
      "Visualizes and generates equivalent fractions.",
      "Recognizes and draws parallel, intersecting and perpendicular lines.",
      "Visualizes, identifies and draws congruent line segments.",
      "Identifies and visualizes symmetry in the environment and in design.",
      "Determines the missing term/s in a given combination of continuous and repeating pattern.",
      "Finds the missing value in a number sentence involving multiplication or division of whole numbers.",
      "Visualizes, and represents, and converts time measure from seconds to minutes, minutes to hours, and hours to a day and vice versa.",
      "Visualizes, and represents, and converts time measure 64.1 days to week, month and year and vice versa 64.2 weeks to months and year and vice versa 64.3 months to year and vice versa.",
      "Visualizes, and represents, and solves problems involving conversion of time measure.",
      "Visualizes, and represents, and converts common units of measure from larger to smaller unit and vice versa: meter and centimeter, kilogram and gram, liter and milliliter.",
      "Visualizes, and represents, and solves routine and non-routine problems involving conversions of common units of measure.",
      "Visualizes, and represents, and finds the capacity of a container using milliliter and liter.",
      "Infers and interprets data presented in different kinds of bar graphs (vertical/ horizontal).",
      "Solves routine and non-routine problems using data presented in a single-bar graph.",
      "Tells whether an event is sure, likely, equally likely, unlikely, and impossible to happen."
   ])
};

export const SCIENCE4_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "matter",
         label: "Matter",
         start: 1,
         count: 10,
         mean: 4,
         stdDev: 2.45,
         ranges: [[0,2.77,"Beginner"],[2.78,6.45,"Basic"],[6.46,10,"Competent"]]
      },
      {
         key: "livingthings",
         label: "Living Things",
         start: 11,
         count: 33,
         mean: 16.69,
         stdDev: 2.69,
         ranges: [[0,15.3,"Beginner"],[15.31,19.4,"Basic"],[19.41,33,"Competent"]]
      },
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 44,
         count: 12,
         mean: 7.23,
         stdDev: 1.64,
         ranges: [[0,6.4,"Beginner"],[6.41,8.87,"Basic"],[8.88,12,"Competent"]]
      },
      {
         key: "earthandspace",
         label: "Earth and Space",
         start: 56,
         count: 10,
         mean: 5,
         stdDev: 1.29,
         ranges: [[0,4.35,"Beginner"],[4.36,6.29,"Basic"],[6.3,10,"Competent"]]
      }
   ],
   totalRanges: [[0,33.91,"Beginner"],[33.92,42.9,"Basic"],[42.91,65,"Competent"]],
   totalSummary: {
      count: 65,
      mean: 36.92,
      stdDev: 5.99
   },
   sections: [
      {
         label: "Matter",
         start: 1,
         end: 10
      },
      {
         label: "Living Things",
         start: 11,
         end: 43
      },
      {
         label: "Force And Motion",
         start: 44,
         end: 55
      },
      {
         label: "Earth and Space",
         start: 56,
         end: 65
      }
   ],
   competencies: toCompetencies([
      "Classify materials based on the ability to absorb water, float, sink, undergo decay.",
      "Identify the effects of decaying materials on one’s health and safety.",
      "Identify the effects of decaying materials on one’s health and safety.",
      "Demonstrate proper disposal of waste according to the properties of its materials.",
      "Demonstrate proper disposal of waste according to the properties of its materials.",
      "Describe changes in solid materials when they are bent, pressed, hammered, or cut.",
      "Describe changes in solid materials when they are bent, pressed, hammered, or cut.",
      "Describe changes in properties of materials when exposed to certain conditions such as temperature or when mixed with other materials.",
      "Describe changes in properties of materials when exposed to certain conditions such as temperature or when mixed with other materials.",
      "Identify changes in materials whether useful or harmful to one’s environment.",
      "Describe the main function of the major organs.",
      "Describe the main function of the major organs.",
      "Communicate that the major organs work together to make the body function properly.",
      "Communicate that the major organs work together to make the body function properly.",
      "Identify the causes and treatment of diseases of the major organs.",
      "Identify the causes and treatment of diseases of the major organs.",
      "Practice habits to maintain a healthy body.",
      "Practice habits to maintain a healthy body.",
      "Infer that body structures help animals adapt and survive in their particular habitat.",
      "Infer that body structures help animals adapt and survive in their particular habitat.",
      "Compare body movements of animals in their habitat.",
      "Make a survey of animals found in the community and their specific habitats.",
      "Make a survey of animals found in the community and their specific habitats.",
      "Choose which animals to raise in a particular habitat.",
      "Identify the specialized structures of terrestrial and aquatic plants.",
      "Identify the specialized structures of terrestrial and aquatic plants.",
      "Conduct investigation on the specialized structures of plants given varying environmental conditions: light, water, temperature, and soil type.",
      "Conduct investigation on the specialized structures of plants given varying environmental conditions: light, water, temperature, and soil type.",
      "Make a survey of plants found in the community and their specific habitats.",
      "Make a survey of plants found in the community and their specific habitats.",
      "Choose which plants to grow in a particular habitat.",
      "Choose which plants to grow in a particular habitat.",
      "Compare the stages in the life cycle of organisms.",
      "Compare the stages in the life cycle of organisms.",
      "Describe the effect of the environment on the life cycle of organisms.",
      "Describe the effect of the environment on the life cycle of organisms.",
      "Describe some types of beneficial interactions among living things.",
      "Describe some types of beneficial interactions among living things.",
      "Describe some types of beneficial interactions among living things.",
      "Conduct investigations to determine environmental conditions needed by living things to survive.",
      "Conduct investigations to determine environmental conditions needed by living things to survive.",
      "Describe the effects of interactions among organism in their environment.",
      "Describe the effects of interactions among organism in their environment.",
      "Explain the effects of force applied to an object.",
      "Explain the effects of force applied to an object.",
      "Practice safety measures in physical activities and proper handling of materials.",
      "Practice safety measures in physical activities and proper handling of materials.",
      "Describe the force exerted by magnets.",
      "Describe the force exerted by magnets.",
      "Describe how light, sound and heat travel.",
      "Describe how light, sound and heat travel.",
      "Investigate properties and characteristics of light and sound.",
      "Investigate properties and characteristics of light and sound.",
      "Describe ways to protect oneself from exposure to excessive light, heat and sound.",
      "Describe ways to protect oneself from exposure to excessive light, heat and sound.",
      "Compare and contrast the characteristics of different types of soil.",
      "Compare and contrast the characteristics of different types of soil.",
      "Explain the use of water from different sources in the context of daily activities.",
      "Describe the importance of the water cycle.",
      "Use weather instruments to measure the different weather components.",
      "Make simple interpretations about the weather as recorded in the weather chart.",
      "Identify safety precautions during different weather conditions.",
      "Describe the changes in the position and length of shadows in the surroundings as the position of the Sun changes.",
      "Describes the role of the Sun in the water cycle.",
      "Describes the role of the Sun in the water cycle."
   ])
};

export const ENGLISH5_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 1,
         count: 8,
         mean: 4.87,
         stdDev: 1.29,
         ranges: [[0,4.22,"Beginner"],[4.23,6.16,"Basic"],[6.17,8,"Competent"]]
      },
      {
         key: "readingComprehension",
         label: "Reading Comprehension",
         start: 9,
         count: 18,
         mean: 10.74,
         stdDev: 1.84,
         ranges: [[0,9.81,"Beginner"],[9.82,12.6,"Basic"],[12.61,18,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar",
         start: 27,
         count: 29,
         mean: 16.57,
         stdDev: 5.62,
         ranges: [[0,13.8,"Beginner"],[13.81,22.2,"Basic"],[22.21,29,"Competent"]]
      },
      {
         key: "viewingComprehension",
         label: "Viewing Comprehension",
         start: 56,
         count: 5,
         mean: 1.78,
         stdDev: 1.24,
         ranges: [[0,1.15,"Beginner"],[1.16,3.02,"Basic"],[3.03,5,"Competent"]]
      }
   ],
   totalRanges: [[0,25.1,"Beginner"],[25.2,33.6,"Basic"],[33.61,60,"Competent"]],
   totalSummary: {
      count: 60,
      mean: 27.96,
      stdDev: 5.62
   },
   sections: [
      {
         label: "Vocabulary",
         start: 1,
         end: 8
      },
      {
         label: "Reading Comprehension",
         start: 9,
         end: 26
      },
      {
         label: "Grammar",
         start: 27,
         end: 55
      },
      {
         label: "Viewing Comprehension",
         start: 56,
         end: 60
      }
   ],
   competencies: toCompetencies([
      "Infer the meaning of unfamiliar words (compound) based on given context clues.",
      "Infer the meaning of unfamiliar words (compound) based on given context clues.",
      "Clarify meaning of words using dictionaries, thesaurus, and/or online resources.",
      "Clarify meaning of words using dictionaries, thesaurus, and/or online resources.",
      "Identify different meanings of content specific words (denotation and connotation) (Science).",
      "Identify different meanings of content specific words (denotation and connotation) (Science).",
      "Infer the meaning of unfamiliar words (compound, affixed) based on.",
      "Infer the meaning of unfamiliar words (compound, affixed) based on.",
      "Infer the theme of literary text.",
      "Infer the theme of literary text.",
      "Distinguish text-types according to purpose.",
      "Distinguish text-types according to purpose.",
      "Analyze figures of speech (simile, metaphor, personification, hyperbole) in a given text.",
      "Analyze figures of speech (simile, metaphor, personification, hyperbole) in a given text.",
      "Analyze figures of speech (simile, metaphor, personification, hyperbole) in a given text.",
      "Analyze figures of speech (simile, metaphor, personification, hyperbole) in a given text.",
      "Main idea, key sentences and supporting details of a given paragraph.",
      "Main idea, key sentences and supporting details of a given paragraph.",
      "Main idea, key sentences and supporting details of a given paragraph.",
      "Distinguish text-types according to features (structural and language).",
      "Distinguish text-types according to features (structural and language).",
      "Distinguish text-types according to features (structural and language).",
      "Distinguish text-types according to features (structural and language).",
      "Distinguish text-types according to features (structural and language).",
      "Distinguish text-types according to features (structural and language).",
      "Distinguish text-types according to features (structural and language).",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Compose clear and coherent sentences using appropriate grammatical structures.",
      "Use a particular kind of sentence for a specific purpose and audience.",
      "Use a particular kind of sentence for a specific purpose and audience.",
      "Use a particular kind of sentence for a specific purpose and audience.",
      "Use a particular kind of sentence for a specific purpose and audience.",
      "Use compound sentences to show cause and effect.",
      "Use compound sentences to show cause and effect.",
      "Use compound sentences to show cause and effect.",
      "Use compound sentences to show cause and effect.",
      "Use compound sentences to show problem- solution relationship of ideas.",
      "Use compound sentences to show problem- solution relationship of ideas.",
      "Use compound sentences to show problem- solution relationship of ideas.",
      "Use compound sentences to show problem- solution relationship of ideas.",
      "Use complex sentences to show cause and effect.",
      "Use complex sentences to show cause and effect.",
      "Use complex sentences to show cause and effect.",
      "Use complex sentences to show cause and effect.",
      "Describe different forms and conventions of film and moving pictures (lights, blocking, direction, characterization, acting, dialog, setting or set-up).",
      "Describe different forms and conventions of film and moving pictures (lights, blocking, direction, characterization, acting, dialog, setting or set-up).",
      "Determine images/ideas that are explicitly used to influence viewers.",
      "Determine images/ideas that are explicitly used to influence viewers.",
      "Analyze how visual and multimedia elements contribute to the meaning of a text."
   ])
};

export const MATH5_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "numbersense",
         label: "Number Sense",
         start: 1,
         count: 34,
         mean: 17.5,
         stdDev: 4.94,
         ranges: [[0,15,"Beginner"],[15.1,22.5,"Basic"],[22.51,34,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 35,
         count: 3,
         mean: 1.48,
         stdDev: 0.73,
         ranges: [[0,1.11,"Beginner"],[1.12,2.21,"Basic"],[2.22,3,"Competent"]]
      },
      {
         key: "algebra",
         label: "Patterns And Algebra",
         start: 38,
         count: 2,
         mean: 0.87,
         stdDev: 0.49,
         ranges: [[0,0.62,"Beginner"],[0.63,1.36,"Basic"],[1.37,2,"Competent"]]
      },
      {
         key: "measurement",
         label: "Measurement",
         start: 40,
         count: 23,
         mean: 12.26,
         stdDev: 2.45,
         ranges: [[0,11,"Beginner"],[11.1,14.7,"Basic"],[14.71,23,"Competent"]]
      },
      {
         key: "statistics",
         label: "Statistics And Probability",
         start: 63,
         count: 3,
         mean: 1.3,
         stdDev: 0.82,
         ranges: [[0,0.88,"Beginner"],[0.89,2.12,"Basic"],[2.13,3,"Competent"]]
      }
   ],
   totalRanges: [[0,26.8,"Beginner"],[26.81,36.7,"Basic"],[36.71,65,"Competent"]],
   totalSummary: {
      count: 65,
      mean: 30.13,
      stdDev: 6.59
   },
   sections: [
      {
         label: "Number Sense",
         start: 1,
         end: 34
      },
      {
         label: "Geometry",
         start: 35,
         end: 37
      },
      {
         label: "Patterns And Algebra",
         start: 38,
         end: 39
      },
      {
         label: "Measurement",
         start: 40,
         end: 62
      },
      {
         label: "Statistics And Probability",
         start: 63,
         end: 65
      }
   ],
   competencies: toCompetencies([
      "Reads and writes numbers up to 10 000 000 in symbols and in words.",
      "Reads and writes numbers up to 10 000 000 in symbols and in words.",
      "Rounds numbers to the nearest Hundred thousand and million.",
      "Rounds numbers to the nearest Hundred thousand and million.",
      "Uses divisibility rules for 4, 8, 12, and 11 to find common factors.",
      "Solves routine and non-routine problems involving factors, multiples, and divisibility rules for 2,3,4,5,6,8,9,10,11, and 12",
      "Simplifies a series of operations on whole numbers involving more than two operations using the PMDAS or GMDAS rule.",
      "Finds the common factors and the GCF of 2–4 numbers using continuous division",
      "Solves real-life problems involving GCF and LCM of 2-3 given numbers.",
      "Subtracts fractions and mixed fractions without and with regrouping.",
      "Subtracts fractions and mixed fractions without and with regrouping.",
      "Solves routine and non-routine Problems involving addition and/or subtraction of fractions using appropriate problem solving strategies and tools.",
      "Multiplies a fraction and a whole number and another fraction",
      "Solves routine or non-routine problems involving multiplication without or with addition or subtraction of fractions and whole numbers using appropriate problem solving strategies and tools.",
      "Divides simple fractions, whole numbers by a fraction and vice versa.",
      "Solves routine and non routine problems involving division without r with any of the other operations of fractions and whole numbers using appropriate problem solving strategies.",
      "Gives the place value and the value of a digit of a given decimal number through ten thousandths",
      "Rounds decimal numbers to the nearest hundredth and thousandth.",
      "Rounds decimal numbers to the nearest hundredth and thousandth.",
      "Compares and arranges decimal Numbers.",
      "Adds and subtracts decimal numbers through thousandths without and with regrouping.",
      "Solves routine or non-routine problems involving addition and subtraction of decimal numbers including money using appropriate problem solving strategies and tools.",
      "Multiplies decimals up to 2 decimal places by 1- to 2-digit whole numbers.",
      "Multiplies decimals with factors up to 2 decimal places.",
      "Solves routine and non-routine problems involving multiplication without or with addition or subtraction of decimals and whole numbers including money using appropriate problem solving strategies and tools.",
      "Divides decimals with up to 2 decimal places.",
      "Divides whole numbers with quotients in decimal form.",
      "Solves routine and non-routine problems involving division without or with any of the other operations of decimals and whole numbers including money using appropriate problem solving strategies and tools.",
      "Expresses ratio using either the colon (:) or fraction.",
      "Finds the missing term in a pair of equivalent ratios.",
      "Recognizes when two quantities are in direct proportion.",
      "Visualizes percent and its relationship to fractions, ratios, and decimal numbers using models",
      "Identifies the base, percentage, and rate in a problem.",
      "Solves routine and non-routine problems involving percentage using appropriate strategies and tools.",
      "Visualizes, names, and describes polygons with 5 or more sides.",
      "Visualizes congruent polygons.",
      "Visualizes and describes solid figures.",
      "Formulates the rule in finding the next term in a sequence.",
      "Uses different strategies (looking for a pattern, working backwards, etc.) to solve for the unknown in simple equations involving one or more operations on whole numbers and fractions",
      "Measures time using a 12-hour and a 24-hour clock.",
      "Measures time using a 12-hour and a 24-hour clock.",
      "Calculates time in the different world time zones in relation to the Philippines.",
      "Solves problems involving time.",
      "Visualizes circumference of a circle.",
      "Measures circumference of a circle using appropriate tools.",
      "Derives a formula in finding the circumference of a circle.",
      "Finds the circumference of a circle.",
      "Solves routine and non-routine problems involving circumference of a circle.",
      "Solves routine and non-routine problems involving circumference of a circle.",
      "Derives a formula in finding the area of a circle .",
      "Finds the area of a given circle.",
      "Solves routine and non-routine problems involving the area of a circle",
      "Solves routine and non-routine problems involving the area of a circle",
      "Creates problems involving a circle, with reasonable answers.",
      "Names the appropriate unit of measure used for measuring the volume of a cube and a rectangle prism.",
      "Derives the formula in finding the volume of a cube and a rectangular prism using cubic cm and cubic m.",
      "Converts cu. cm to cu. m and vice versa; cu.cm to L and vice versa",
      "Finds the volume of a given cube and rectangular prism using cu. cm and cu. M.",
      "Estimates and uses appropriate units of measure for volume.",
      "Solves routine and non-routine problems involving volume of a cube and rectangular prism in real-life situations using appropriate strategies and tools",
      "Reads and measures temperature using thermometer (alcohol and/or digital) in degree Celsius",
      "Solves routine and non-routine problems involving temperature in real-life situations.",
      "Interprets data presented in different kinds of line graphs (single to double line graph).",
      "Solves routine and non-routine problems using data presented in a line graph.",
      "Draws inferences based on data presented in a line graph."
   ])
};

export const SCIENCE5_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "matter",
         label: "Matter",
         start: 1,
         count: 6,
         mean: 3.04,
         stdDev: 1.19,
         ranges: [[0,2.44,"Beginner"],[2.45,4.23,"Basic"],[4.24,6,"Competent"]]
      },
      {
         key: "livingthings",
         label: "Living Things",
         start: 7,
         count: 16,
         mean: 7.3,
         stdDev: 1.99,
         ranges: [[0,5.3,"Beginner"],[5.31,8.29,"Basic"],[8.3,16,"Competent"]]
      },
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 23,
         count: 18,
         mean: 10.87,
         stdDev: 2.22,
         ranges: [[0,7.75,"Beginner"],[7.76,11.1,"Basic"],[11.2,18,"Competent"]]
      },
      {
         key: "earthandspace",
         label: "Earth and Space",
         start: 41,
         count: 10,
         mean: 5.22,
         stdDev: 2.47,
         ranges: [[0,3.98,"Beginner"],[3.99,7.69,"Basic"],[7.7,10,"Competent"]]
      }
   ],
   totalRanges: [[0,22.8,"Beginner"],[22.81,30.7,"Basic"],[30.71,50,"Competent"]],
   totalSummary: {
      count: 50,
      mean: 25.43,
      stdDev: 5.3
   },
   sections: [
      {
         label: "Matter",
         start: 1,
         end: 6
      },
      {
         label: "Living Things",
         start: 7,
         end: 22
      },
      {
         label: "Force And Motion",
         start: 23,
         end: 40
      },
      {
         label: "Earth and Space",
         start: 41,
         end: 50
      }
   ],
   competencies: toCompetencies([
      "Use the properties of materials whether they are useful or harmful.",
      "Use the properties of materials whether they are useful or harmful.",
      "Investigate changes that happen in materials under the following conditions.",
      "Investigate changes that happen in materials under the following conditions.",
      "Recognize the importance of recycle, reduce, reuse, recover and repair in waste management.",
      "Recognize the importance of recycle, reduce, reuse, recover and repair in waste management.",
      "Describe the parts of the reproductive system and their functions.",
      "Describe the parts of the reproductive system and their functions.",
      "Explain the menstrual cycle.",
      "Explain the menstrual cycle.",
      "Give ways of taking care of the reproductive organs.",
      "Give ways of taking care of the reproductive organs.",
      "Describe the different modes of reproduction in animals such as butterflies, mosquitoes, frogs, cats and dogs.",
      "Describe the different modes of reproduction in animals such as butterflies, mosquitoes, frogs, cats and dogs.",
      "Describe the reproductive parts in plants and their functions.",
      "Describe the reproductive parts in plants and their functions.",
      "Describe the different modes of reproduction in flowering and non-flowering plants such as moss, fern, mongo and others.",
      "Describe the different modes of reproduction in flowering and non-flowering plants such as moss, fern, mongo and others.",
      "Discuss the interactions among living things and non-living things in estuaries and intertidal zones.",
      "Discuss the interactions among living things and non-living things in estuaries and intertidal zones.",
      "Explain the need to protect and conserve estuaries and intertidal zones.",
      "Explain the need to protect and conserve estuaries and intertidal zones.",
      "Describe the motion of an object by tracing and measuring its change in position (distance travelled) over a period of time.",
      "Describe the motion of an object by tracing and measuring its change in position (distance travelled) over a period of time.",
      "Use appropriate measuring tools and correct standard units.",
      "Use appropriate measuring tools and correct standard units.",
      "Discuss why some materials are good conductors of heat and electricity.",
      "Discuss why some materials are good conductors of heat and electricity.",
      "Infer how black and colored objects affect the ability to absorb heat.",
      "Infer how black and colored objects affect the ability to absorb heat.",
      "Relate the ability of the material to block, absorb or transmit light to its use.",
      "Relate the ability of the material to block, absorb or transmit light to its use.",
      "Infer the conditions necessary to make a bulb light up.",
      "Infer the conditions necessary to make a bulb light up.",
      "Determine the effects of changing the number or type of components in a circuit.",
      "Determine the effects of changing the number or type of components in a circuit.",
      "Infer that electricity can be used to produce magnets.",
      "Infer that electricity can be used to produce magnets.",
      "Design an experiment to determine the factors that affect the strength of the electromagnet.",
      "Design an experiment to determine the factors that affect the strength of the electromagnet.",
      "Describe how rocks turn into soil.",
      "Describe how rocks turn into soil.",
      "Investigate extent of soil erosion in the community and its effects on living things and the environment.",
      "Investigate extent of soil erosion in the community and its effects on living things and the environment.",
      "Communicate the data collected from the investigation on soil erosion.",
      "Communicate the data collected from the investigation on soil erosion.",
      "Observe the changes in the weather before, during and after a typhoon.",
      "Observe the changes in the weather before, during and after a typhoon.",
      "Identify star patterns that can be seen at particular times of the year.",
      "Identify star patterns that can be seen at particular times of the year."
   ])
};

export const ENGLISH6_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 1,
         count: 6,
         mean: 4.04,
         stdDev: 1.4,
         ranges: [[0,3.33,"Beginner"],[3.34,5.45,"Basic"],[5.46,6,"Competent"]]
      },
      {
         key: "readingComprehension",
         label: "Reading Comprehension",
         start: 7,
         count: 14,
         mean: 8.13,
         stdDev: 1.73,
         ranges: [[0,7.26,"Beginner"],[7.27,9.86,"Basic"],[9.87,14,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar",
         start: 21,
         count: 30,
         mean: 21.38,
         stdDev: 2.75,
         ranges: [[0,20,"Beginner"],[20.1,24.1,"Basic"],[24.11,30,"Competent"]]
      }
   ],
   totalRanges: [[0,28.4,"Beginner"],[28.5,34.9,"Basic"],[34.91,50,"Competent"]],
   totalSummary: {
      count: 50,
      mean: 30.54,
      stdDev: 4.33
   },
   sections: [
      {
         label: "Vocabulary",
         start: 1,
         end: 6
      },
      {
         label: "Reading Comprehension",
         start: 7,
         end: 20
      },
      {
         label: "Grammar",
         start: 21,
         end: 50
      }
   ],
   competencies: toCompetencies([
      "Infer meaning of idiomatic expressions using context clues.",
      "Infer meaning of idiomatic expressions using context clues.",
      "Infer meaning of idiomatic expressions using context clues.",
      "Infer meaning of borrowed words and content specific terms using context clues, affixes and roots, other strategies.",
      "Infer meaning of borrowed words and content specific terms using context clues, affixes and roots, other strategies.",
      "Infer meaning of borrowed words and content specific terms using context clues, affixes and roots, other strategies.",
      "Determine tone, mood, and purpose of the author.",
      "Determine tone, mood, and purpose of the author.",
      "Determine tone, mood, and purpose of the author.",
      "Analyze figures of speech (simile, Metaphor, hyperbole, irony, euphemism).",
      "Analyze figures of speech (simile, Metaphor, hyperbole, irony, euphemism).",
      "Analyze figures of speech (simile, Metaphor, hyperbole, irony, euphemism).",
      "Note significant details of informational texts.",
      "Note significant details of informational texts.",
      "Note significant details of informational texts.",
      "Note significant details of informational texts.",
      "Note significant details of informational texts.",
      "Distinguish text-types according to purpose and language features.",
      "Distinguish text-types according to purpose and language features.",
      "Distinguish text-types according to purpose and language features.",
      "Use appropriate grammatical structures in a sentence: Pluralization of regular nouns.",
      "Use appropriate grammatical structures in a sentence: Pluralization of regular nouns.",
      "Use appropriate grammatical structures in a sentence: Pluralization of regular nouns.",
      "Use appropriate grammatical structures in a sentence: Pluralization of regular nouns.",
      "Use appropriate grammatical structures in a sentence: Pluralization of regular nouns.",
      "Use appropriate grammatical structures in a sentence: Pluralization of regular nouns.",
      "Use appropriate grammatical structures in a sentence: Tenses of verbs.",
      "Use appropriate grammatical structures in a sentence: Tenses of verbs.",
      "Use appropriate grammatical structures in a sentence: Tenses of verbs.",
      "Use appropriate grammatical structures in a sentence: Modals",
      "Use appropriate grammatical structures in a sentence: Modals",
      "Use appropriate grammatical structures in a sentence: Pronoun reference agreement (number, case, gender).",
      "Use appropriate grammatical structures in a sentence: Pronoun reference agreement (number, case, gender).",
      "Use appropriate grammatical structures in a sentence: Pronoun reference agreement (number, case, gender).",
      "Use appropriate grammatical structures in a sentence: subject verb agreement.",
      "Use appropriate grammatical structures in a sentence: subject verb agreement.",
      "Use appropriate grammatical structures in a sentence: subject verb agreement.",
      "Use appropriate grammatical structures in a sentence: Adverbs of intensity, frequency, manner, place and time.",
      "Use appropriate grammatical structures in a sentence: Adverbs of intensity, frequency, manner, place and time.",
      "Use appropriate grammatical structures in a sentence: Adverbs of intensity, frequency, manner, place and time.",
      "Use appropriate grammatical structures in a sentence: Preposition.",
      "Use appropriate grammatical structures in a sentence: Preposition.",
      "Use appropriate grammatical structures in a sentence: Preposition.",
      "Use appropriate grammatical structures in a sentence: Subordinate and coordinate conjunction.",
      "Use appropriate grammatical structures in a sentence: Subordinate and coordinate conjunction.",
      "Use appropriate grammatical structures in a sentence: Subordinate and coordinate conjunction.",
      "Use various types and kinds of sentences for effective communication of information/Ideas (compound, complex sentences).",
      "Use various types and kinds of sentences for effective communication of information/Ideas (compound, complex sentences).",
      "Use various types and kinds of sentences for effective communication of information/Ideas (compound, complex sentences).",
      "Use various types and kinds of sentences for effective communication of information/Ideas (compound, complex sentences)."
   ])
};

export const MATH6_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "numbersense",
         label: "Number Sense",
         start: 1,
         count: 32,
         mean: 14.67,
         stdDev: 5.84,
         ranges: [[0,11.7,"Beginner"],[11.71,20.5,"Basic"],[20.51,32,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 33,
         count: 3,
         mean: 1.83,
         stdDev: 1.13,
         ranges: [[0,1.11,"Beginner"],[1.12,2.26,"Basic"],[2.27,3,"Competent"]]
      },
      {
         key: "algebra",
         label: "Patterns And Algebra",
         start: 36,
         count: 6,
         mean: 1.75,
         stdDev: 0.61,
         ranges: [[0,2.44,"Beginner"],[2.45,3.36,"Basic"],[3.37,6,"Competent"]]
      },
      {
         key: "measurement",
         label: "Measurement",
         start: 42,
         count: 6,
         mean: 4.13,
         stdDev: 1.15,
         ranges: [[0,3.55,"Beginner"],[3.56,5.28,"Basic"],[5.29,6,"Competent"]]
      },
      {
         key: "statistics",
         label: "Statistics And Probability",
         start: 48,
         count: 8,
         mean: 4.88,
         stdDev: 1.12,
         ranges: [[0,4.31,"Beginner"],[4.32,6,"Basic"],[6.01,8,"Competent"]]
      }
   ],
   totalRanges: [[0,24.4,"Beginner"],[24.41,36,"Basic"],[36.01,55,"Competent"]],
   totalSummary: {
      count: 55,
      mean: 28.25,
      stdDev: 7.73
   },
   sections: [
      {
         label: "Number Sense",
         start: 1,
         end: 32
      },
      {
         label: "Geometry",
         start: 33,
         end: 35
      },
      {
         label: "Patterns And Algebra",
         start: 36,
         end: 41
      },
      {
         label: "Measurement",
         start: 42,
         end: 46
      },
      {
         label: "Statistics And Probability",
         start: 48,
         end: 55
      }
   ],
   competencies: toCompetencies([
      "Adds and subtracts simple fractions and mixed numbers without or with regrouping.",
      "Solves routine and non-routine problems involving addition and/or subtraction of fractions using appropriate problem solving strategies and tools.",
      "Multiplies simple fractions and mixed fractions.",
      "Solves routine or non-routine problems involving multiplication without or with addition or subtraction of fractions and mixed fractions using appropriate problem solving strategies and tools.",
      "Divides simple fractions and mixed Fractions.",
      "Solves routine or non-routine problems involving division without or with any of the other operations of fractions and mixed fractions using appropriate problem solving strategies and tools.",
      "Adds and subtracts decimals and mixed decimals through ten thousandths without or with regrouping.",
      "Creates problems (with reasonable answers) involving addition and/or subtraction of decimals and mixed decimals.",
      "Solves routine and non-routine problems involving multiplication of decimals and mixed decimals including money using appropriate problem solving strategies.",
      "Solves multi-step problems involving multiplication and addition or subtraction of decimals, mixed decimals and whole numbers including money using appropriate problem solving strategies and tools.",
      "Divides whole numbers by decimals up to 2 decimal places and vice versa.",
      "Divides decimals/mixed decimals up to 2 decimal places.",
      "Divides decimals up to 4 decimal places by 0.1, 0.01, and 0.001.",
      "Divides decimals up to 2 decimal places by 10, 100, and 1 000 mentally.",
      "Differentiates terminating from repeating, non-terminating decimal quotients.",
      "Solves routine and non-routine problems involving division of decimals, mixed decimals, and whole numbers including money using appropriate problem solving strategies and tools.",
      "Solves multi-step routine and non-routine problems involving division and any of the other operations of decimals, mixed decimals, and whole numbers including money using appropriate problem solving strategies and tools.",
      "Expresses one value as a fraction of another given their ratio and vice versa.",
      "Expresses one value as a fraction of another given their ratio and vice versa.",
      "Sets up proportions for groups of objects or numbers and for given situations.",
      "Finds a missing term in a proportion (direct, inverse, and partitive).",
      "Solves problems involving direct proportion, partitive proportion, and inverse proportion in different contexts such as distance, rate, and time using appropriate strategies and tools.",
      "Creates problems involving ratio and proportion, with reasonable answers.",
      "Finds the percentage or rate or percent in a given problem.",
      "Solves routine and non-routine problems involving finding the percentage, rate and base using appropriate strategies and tools.",
      "Solves percent problems such as percent of increase/ decrease (discounts, original price, rate of discount, sale price, marked-up price), commission, sales tax, and simple interest.",
      "Creates problems involving percent, with reasonable answers.",
      "Gives the value of numbers expressed in exponential notation.",
      "Performs two or more different operations on whole numbers with or without exponents and grouping symbols.",
      "Compares integers with other numbers such as whole numbers, fractions, and decimals.",
      "Describes and interprets the basic operations on integers using materials such as algebra tiles, counters, chips, and card.",
      "Solves routine and non-routine problems involving basic operations of integers using appropriate strategies and tools.",
      "Differentiates solid figures from plane figures.",
      "IIlustrates the different solid figures using various concrete and pictorial models.",
      "Identifies the nets of the following space figures: cube, prism, pyramid, cylinder, cone, and sphere using plane figures.",
      "Formulates the rule in finding the nth term using different strategies (looking for a pattern, guessing and checking, working backwards).",
      "Differentiates expression from Equation.",
      "Defines a variable in an algebraic expression and equation.",
      "Represents quantities in real-life situations using algebraic expressions and equations.",
      "Solves routine and non-routine problems involving different types of numerical expressions and equations such as 7+ 9 =___ + 6.",
      "Creates routine and non-routine problems involving numerical expressions and equations.",
      "Solves problems involving average rate and speed.",
      "Finds the area of composite figures formed by any two or more of the following: triangle, square, rectangle, circle, and semi-circle.",
      "Solves routine and non-routine problems involving area of composite figures formed by any two or more of the following: triangle, square, rectangle, circle, and semi-circle.",
      "Visualizes and describes surface area and names the unit of measure used for measuring the surface area of solid/space figures.",
      "Finds the surface area of cubes, prisms, pyramids, cylinders, cones, and spheres.",
      "Solves word problems involving measurement of surface area.",
      "Determines the relationship of the volume between 70.1 a rectangular prism and a pyramid; 70.2 a cylinder and a cone; 70.3 and a cylinder and sphere.",
      "Derives the formula for finding the volume of cylinders, pyramids, cones, and spheres.",
      "Solves routine and non-routine problems involving volumes of solids.",
      "Interprets data presented in a pie graph",
      "Solves routine and non-routine problems using data presented in a pie graph.",
      "Describes the meaning of probability such as 50% chance of rain and one in a million chance of winning.",
      "Solves routine and non-routine problems involving experimental and theoretical probability.",
      "Solves routine and non-routine problems involving electric and water consumption."
   ])
};

export const SCIENCE6_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "matter",
         label: "Matter",
         start: 1,
         count: 5,
         mean: 1.25,
         stdDev: 1.11,
         ranges: [[0,1.69,"Beginner"],[1.7,3.36,"Basic"],[3.36,5,"Competent"]]
      },
      {
         key: "livingthings",
         label: "Living Things",
         start: 6,
         count: 12,
         mean: 6.13,
         stdDev: 1.08,
         ranges: [[0,5.58,"Beginner"],[5.59,7.21,"Basic"],[7.22,12,"Competent"]]
      },
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 18,
         count: 8,
         mean: 4.79,
         stdDev: 1.47,
         ranges: [[0,4.05,"Beginner"],[4.06,6.26,"Basic"],[6.27,8,"Competent"]]
      },
      {
         key: "earthandspace",
         label: "Earth and Space",
         start: 26,
         count: 15,
         mean: 6.21,
         stdDev: 1.54,
         ranges: [[0,5.43,"Beginner"],[5.44,7.75,"Basic"],[7.76,15,"Competent"]]
      }
   ],
   totalRanges: [[0,20.05,"Beginner"],[20.51,26.2,"Basic"],[26.21,40,"Competent"]],
   totalSummary: {
      count: 40,
      mean: 22.38,
      stdDev: 3.82
   },
   sections: [
      {
         label: "Matter",
         start: 1,
         end: 5
      },
      {
         label: "Living Things",
         start: 6,
         end: 17
      },
      {
         label: "Force And Motion",
         start: 18,
         end: 25
      },
      {
         label: "Earth and Space",
         start: 26,
         end: 40
      }
   ],
   competencies: toCompetencies([
      "Use the properties of materials whether they are useful or harmful.",
      "Use the properties of materials whether they are useful or harmful.",
      "Investigate changes that happen in materials under the following conditions.",
      "Investigate changes that happen in materials under the following conditions.",
      "Recognize the importance of recycle, reduce, reuse, recover and repair in waste management.",
      "Recognize the importance of recycle, reduce, reuse, recover and repair in waste management.",
      "Describe the parts of the reproductive system and their functions.",
      "Describe the parts of the reproductive system and their functions.",
      "Explain the menstrual cycle.",
      "Explain the menstrual cycle.",
      "Give ways of taking care of the reproductive organs.",
      "Give ways of taking care of the reproductive organs.",
      "Describe the different modes of reproduction in animals such as butterflies, mosquitoes, frogs, cats and dogs.",
      "Describe the different modes of reproduction in animals such as butterflies, mosquitoes, frogs, cats and dogs.",
      "Describe the reproductive parts in plants and their functions.",
      "Describe the reproductive parts in plants and their functions.",
      "Describe the different modes of reproduction in flowering and non-flowering plants such as moss, fern, mongo and others.",
      "Describe the different modes of reproduction in flowering and non-flowering plants such as moss, fern, mongo and others.",
      "Discuss the interactions among living things and non-living things in estuaries and intertidal zones.",
      "Discuss the interactions among living things and non-living things in estuaries and intertidal zones.",
      "Explain the need to protect and conserve estuaries and intertidal zones.",
      "Explain the need to protect and conserve estuaries and intertidal zones.",
      "Describe the motion of an object by tracing and measuring its change in position (distance travelled) over a period of time.",
      "Describe the motion of an object by tracing and measuring its change in position (distance travelled) over a period of time.",
      "Use appropriate measuring tools and correct standard units.",
      "Use appropriate measuring tools and correct standard units.",
      "Discuss why some materials are good conductors of heat and electricity.",
      "Discuss why some materials are good conductors of heat and electricity.",
      "Infer how black and colored objects affect the ability to absorb heat.",
      "Infer how black and colored objects affect the ability to absorb heat.",
      "Relate the ability of the material to block, absorb or transmit light to its use.",
      "Relate the ability of the material to block, absorb or transmit light to its use.",
      "Infer the conditions necessary to make a bulb light up.",
      "Infer the conditions necessary to make a bulb light up.",
      "Determine the effects of changing the number or type of components in a circuit.",
      "Determine the effects of changing the number or type of components in a circuit.",
      "Infer that electricity can be used to produce magnets.",
      "Infer that electricity can be used to produce magnets.",
      "Design an experiment to determine the factors that affect the strength of the electromagnet.",
      "Design an experiment to determine the factors that affect the strength of the electromagnet."
   ])
};

export const ENGLISH7_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "viewingomprehension",
         label: "Viewing Comprehension",
         start: 1,
         count: 6,
         mean: 9.81,
         stdDev: 3.87,
         ranges: [[0,2,"Beginner"],[2.01,7.77,"Basic"],[7.78,6,"Competent"]]
      },
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 7,
         count: 24,
         mean: 9.43,
         stdDev: 3.48,
         ranges: [[0,7.68,"Beginner"],[7.69,12.9,"Basic"],[12.91,24,"Competent"]]
      },
      {
         key: "literature",
         label: "Literature",
         start: 31,
         count: 6,
         mean: 2.06,
         stdDev: 1.48,
         ranges: [[0,1.31,"Beginner"],[1.32,3.54,"Basic"],[3.55,6,"Competent"]]
      },
      {
         key: "writing",
         label: "Writing and Composition",
         start: 37,
         count: 7,
         mean: 3.69,
         stdDev: 0.79,
         ranges: [[0,3.29,"Beginner"],[3.3,4.48,"Basic"],[4.49,7,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar Awareness",
         start: 44,
         count: 17,
         mean: 9.81,
         stdDev: 3.87,
         ranges: [[0,7.87,"Beginner"],[7.88,13.7,"Basic"],[13.71,17,"Competent"]]
      }
   ],
   totalRanges: [[0,22.7,"Beginner"],[22.71,35.5,"Basic"],[35.51,60,"Competent"]],
   totalSummary: {
      count: 60,
      mean: 26.94,
      stdDev: 8.51
   },
   sections: [
      {
         label: "Viewing Comprehension",
         start: 1,
         end: 6
      },
      {
         label: "Vocabulary",
         start: 7,
         end: 30
      },
      {
         label: "Literature",
         start: 31,
         end: 36
      },
      {
         label: "Writing and Composition",
         start: 37,
         end: 43
      },
      {
         label: "Grammar Awareness",
         start: 44,
         end: 60
      }
   ],
   competencies: toCompetencies([
      "Give the meaning of given signs and symbols (road signs, prohibited signs, etc.).",
      "Give the meaning of given signs and symbols (road signs, prohibited signs, etc.).",
      "Give the meaning of given signs and symbols (road signs, prohibited signs, etc.).",
      "Predict the gist of the material viewed based on the title, pictures, and excerpts of the material viewed.",
      "Raise questions about a material viewed.",
      "Determine the key message conveyed in the material viewed.",
      "Distinguish between slang and colloquial expressions in conversations.",
      "Distinguish between slang and colloquial expressions in conversations.",
      "Distinguish between slang and colloquial expressions in conversations.",
      "Distinguish between slang and colloquial expressions in conversations.",
      "Use appropriate idiomatic expressions in a variety of basic interpersonal communicative situations.",
      "Use appropriate idiomatic expressions in a variety of basic interpersonal communicative situations.",
      "Use appropriate idiomatic expressions in a variety of basic interpersonal communicative situations.",
      "Select an appropriate colloquial or idiomatic word or expression as a substitute for another word or expression.",
      "Select an appropriate colloquial or idiomatic word or expression as a substitute for another word or expression.",
      "Discriminate between literal and figurative language.",
      "Discriminate between literal and figurative language.",
      "Identify figures of speech that show comparison (simile, metaphor, personification, (irony, oxymoron, paradox ).",
      "Identify figures of speech that show comparison (simile, metaphor, personification, (irony, oxymoron, paradox ).",
      "Identify figures of speech that show comparison (simile, metaphor, personification, (irony, oxymoron, paradox ).",
      "Identify collocations used in a selection.",
      "Identify collocations used in a selection.",
      "Identify words or expressions with part-whole (partitive) relations.",
      "Identify words or expressions with part-whole (partitive) relations.",
      "Use lexical and contextual cues in understanding unfamiliar words and expressions.",
      "Use lexical and contextual cues in understanding unfamiliar words and expressions.",
      "Give the various meanings of identified homonymous or polysemous words or expressions.",
      "Give the various meanings of identified homonymous or polysemous words or expressions.",
      "Create or expand word clines.",
      "Create or expand word clines.",
      "Identify the distinguishing features of proverbs, myths, and legends.",
      "Explain the literary devices used.",
      "Determine the tone, mood, technique, and purpose of the author.",
      "Determine the tone, mood, technique, and purpose of the author.",
      "Determine the tone, mood, technique, and purpose of the author.",
      "Discover the conflicts presented in literary selections and the need to resolve those conflicts in non-violent ways.",
      "Recognize the common purposes for writing.",
      "Identify key ideas.",
      "Identify supporting details.",
      "Recognize the parts of a simple paragraph.",
      "Recognize the parts of a simple paragraph.",
      "Recognize the parts of a simple paragraph.",
      "Identify basic features and kinds of paragraph.",
      "Observe correct subject-verb agreement.",
      "Observe correct subject-verb agreement.",
      "Observe correct subject-verb agreement.",
      "Observe correct subject-verb agreement.",
      "Use phrases, clauses, and sentences appropriately and meaningfully.",
      "Use phrases, clauses, and sentences appropriately and meaningfully.",
      "Link sentences using logical connectors that signal chronological and logical sequence and summation.",
      "Use the passive and active voice meaningfully in varied contexts.",
      "Use the passive and active voice meaningfully in varied contexts.",
      "Use the passive and active voice meaningfully in varied contexts.",
      "Use the passive and active voice meaningfully in varied contexts.",
      "Use imperatives and prepositions when giving instructions. Use imperatives and prepositions when giving instructions.",
      "Use imperatives and prepositions when giving instructions.",
      "Use imperatives and prepositions when giving instructions.",
      "Use verbs when giving information and making explanations.",
      "Formulate who, what, when, where, why, and how questions.",
      "Formulate who, what, when, where, why, and how questions."
   ])
};

export const MATH7_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "numbersense",
         label: "Number Sense",
         start: 1,
         count: 19,
         mean: 8.81,
         stdDev: 2.26,
         ranges: [[0,7.67,"Beginner"],[7.68,11.1,"Basic"],[11.11,19,"Competent"]]
      },
      {
         key: "measurement",
         label: "Measurement",
         start: 20,
         count: 5,
         mean: 2.19,
         stdDev: 1.11,
         ranges: [[0,1.63,"Beginner"],[1.64,3.3,"Basic"],[3.31,5,"Competent"]]
      },
      {
         key: "algebra",
         label: "Patterns And Algebra",
         start: 25,
         count: 22,
         mean: 11.19,
         stdDev: 1.11,
         ranges: [[0,10.6,"Beginner"],[10.61,12.3,"Basic"],[12.31,22,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 47,
         count: 10,
         mean: 6.88,
         stdDev: 0.81,
         ranges: [[0,6.47,"Beginner"],[6.48,7.69,"Basic"],[7.7,10,"Competent"]]
      },
      {
         key: "statistics",
         label: "Statistics And Probability",
         start: 57,
         count: 4,
         mean: 2.25,
         stdDev: 0.45,
         ranges: [[0,2.02,"Beginner"],[2.03,2.7,"Basic"],[2.71,4,"Competent"]]
      }
   ],
   totalRanges: [[0,31.2,"Beginner"],[31.21,37.5,"Basic"],[37.51,60,"Competent"]],
   totalSummary: {
      count: 60,
      mean: 33.31,
      stdDev: 4.19
   },
   sections: [
      {
         label: "Number Sense",
         start: 1,
         end: 19
      },
      {
         label: "Measurement",
         start: 20,
         end: 24
      },
      {
         label: "Patterns And Algebra",
         start: 25,
         end: 46
      },
      {
         label: "Geometry",
         start: 47,
         end: 56
      },
      {
         label: "Statistics And Probability",
         start: 57,
         end: 60
      }
   ],
   competencies: toCompetencies([
      "Number Sense: Illustrates the union and intersection of sets and the difference of two sets.",
      "Number Sense: Illustrates the union and intersection of sets and the difference of two sets.",
      "Number Sense: solves problems involving sets.",
      "Number Sense: solves problems involving sets.",
      "Number Sense: Represents the absolute value of a number on a number line as the distance of a number from 0.",
      "Number Sense: Represents the absolute value of a number on a number line as the distance of a number from 0.",
      "Number Sense: Performs fundamental operations on integers.",
      "Number Sense: Performs fundamental operations on integers.",
      "Expresses rational numbers from fraction form to decimal form and vice versa.",
      "Number Sense: Expresses rational numbers from fraction form to decimal form and vice versa.",
      "Number Sense: Performs operations on rational numbers.",
      "Number Sense: Performs operations on rational numbers.",
      "Number Sense: Estimates the square root of a whole number to the nearest hundredth.",
      "Number Sense: Estimates the square root of a whole number to the nearest hundredth.",
      "Plots irrational numbers (up to square roots) on a number line.",
      "Number Sense: Determines between what two integers the square root of a number is.",
      "Number Sense: Writes numbers in scientific notation and vice versa.",
      "Number Sense: Writes numbers in scientific notation and vice versa.",
      "Solves problems involving real numbers.",
      "Measurement: Solves problems involving conversion of units of measurement.",
      "Measurement: Approximates the measures of quantities particularly length , weight/mass, volume, time, angle and temperature and rate.",
      "Measurement: Converts measurements from one unit to another in both Metric and English systems.",
      "Measurement: Converts measurements from one unit to another in both Metric and English systems.",
      "Measurement: Converts measurements from one unit to another in both Metric and English systems.",
      "Patterns and Algebra: Translates English phrases to mathematical phrases and vice versa.",
      "Patterns and Algebra: Translates English phrases to mathematical phrases and vice versa.",
      "Patterns and Algebra: Finds the solution of linear equation or inequality in one variable.",
      "Finds the solution of linear equation or inequality in one variable.",
      "Patterns and Algebra: Evaluates algebraic expressions for given values of the variables.",
      "Patterns and Algebra: Evaluates algebraic expressions for given values of the variables.",
      "Patterns and Algebra: Classifies algebraic expressions which are polynomials according to degree and number of terms.",
      "Patterns and Algebra: Classifies algebraic expressions which are polynomials according to degree and number of terms.",
      "Patterns and Algebra: Adds and subtracts polynomials.",
      "Patterns and Algebra: Adds and subtracts polynomials.",
      "Patterns and Algebra: Multiplies polynomials.",
      "Patterns and Algebra: Divides polynomials.",
      "Patterns and Algebra: Uses models and algebraic methods to find the: (a) product of two binomials.",
      "Patterns and Algebra: Uses models and algebraic methods to find the: (a) product of two binomials.",
      "Patterns and Algebra: Uses models and algebraic methods to find the: (b) product of the sum and difference of two terms.",
      "Patterns and Algebra: Uses models and algebraic methods to find the (c) square of a binomial.",
      "Patterns and Algebra: Uses models and algebraic methods to find the (c) square of a binomial.",
      "Patterns and Algebra: Multiplies polynomials.",
      "Patterns and Algebra: Translates English sentences to mathematical sentences and vice versa.",
      "Patterns and Algebra: Finds the solution of linear equation or inequality in one variable.",
      "Patterns and Algebra: Finds the solution of linear equation or inequality in one variable.",
      "Patterns and Algebra: Finds the solution of linear equation or inequality in one variable.",
      "Geometry: Classifies the different kinds of angles.",
      "Geometry: Classifies the different kinds of angles.",
      "Geometry: Solves problems involving sides and angles of a polygon.",
      "Geometry: Derives relationships of geometric figures using measurements and by inductive reasoning; supplementary angles, complementary angles, congruent angles, vertical angles, adjacent angles, linear pairs, perpendicular lines, and parallel lines.",
      "Translates English phrases to mathematical phrases and vice versa.",
      "Solves problems involving real numbers.",
      "Solves problems involving algebraic expression.",
      "Solves linear equation or inequality in one variable involving absolute value by: (a) graphing; and (b) algebraic methods.",
      "Expresses rational numbers from fraction form to decimal form and vice versa.",
      "Expresses rational numbers from fraction form to decimal form and vice versa.",
      "Calculates the measures of central tendency of ungrouped and grouped data.",
      "Evaluates algebraic expressions for given values of the variables.",
      "Solves problems involving real numbers.",
      "Performs operations on rational numbers."
   ])
};

export const SCIENCE7_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "matter",
         label: "Matter",
         start: 1,
         count: 13,
         mean: 7.3,
         stdDev: 2,
         ranges: [[0,6.12,"Beginner"],[6.13,9.13,"Basic"],[9.14,13,"Competent"]]
      },
      {
         key: "livingthings",
         label: "Living Things",
         start: 14,
         count: 25,
         mean: 11.31,
         stdDev: 2.33,
         ranges: [[0,10.1,"Beginner"],[10.11,13.6,"Basic"],[13.61,25,"Competent"]]
      },
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 39,
         count: 24,
         mean: 12.5,
         stdDev: 1.63,
         ranges: [[0,11.7,"Beginner"],[11.71,14.1,"Basic"],[14.11,24,"Competent"]]
      },
      {
         key: "earthandspace",
         label: "Earth and Space",
         start: 63,
         count: 8,
         mean: 4.56,
         stdDev: 1.5,
         ranges: [[0,3.8,"Beginner"],[3.81,6.06,"Basic"],[6.07,8,"Competent"]]
      }
   ],
   totalRanges: [[0,28.3,"Beginner"],[28.31,34.9,"Basic"],[34.91,70,"Competent"]],
   totalSummary: {
      count: 70,
      mean: 30.5,
      stdDev: 4.43
   },
   sections: [
      {
         label: "Matter",
         start: 1,
         end: 13
      },
      {
         label: "Living Things",
         start: 14,
         end: 38
      },
      {
         label: "Force And Motion",
         start: 39,
         end: 62
      },
      {
         label: "Earth and Space",
         start: 63,
         end: 70
      }
   ],
   competencies: toCompetencies([
      "Describe the components of a scientific investigation.",
      "Describe the components of a scientific investigation.",
      "Investigate properties of unsaturated or saturated solutions.",
      "Investigate properties of unsaturated or saturated solutions.",
      "Express concentrations of solutions quantitatively by preparing different concentrations of mixtures according to uses and availability of materials.",
      "Express concentrations of solutions quantitatively by preparing different concentrations of mixtures according to uses and availability of materials.",
      "Distinguish mixtures from substances based on a set of properties.",
      "Distinguish mixtures from substances based on a set of properties.",
      "Recognize that substances are classified into elements and compounds.",
      "Recognize that substances are classified into elements and compounds.",
      "Investigate properties of acidic and basic mixtures using natural indicators.",
      "Investigate properties of acidic and basic mixtures using natural indicators.",
      "Describe some properties of metals and non-metals such as luster, malleability, ductility, and conductivity.",
      "Identify parts of the microscope and their functions.",
      "Identify parts of the microscope and their functions.",
      "Identify parts of the microscope and their functions.",
      "Focus specimens using the compound microscope.",
      "Focus specimens using the compound microscope.",
      "Describe the different levels of biological organization from cell to biosphere.",
      "Describe the different levels of biological organization from cell to biosphere.",
      "Differentiate plant and animal cells according to presence or absence of certain organelles.",
      "Differentiate plant and animal cells according to presence or absence of certain organelles.",
      "Explain why the cell is considered the basic structural and functional unit of all organisms.",
      "Explain why the cell is considered the basic structural and functional unit of all organisms.",
      "Identify beneficial and harmful microorganisms.",
      "Identify beneficial and harmful microorganisms.",
      "Differentiate asexual from sexual reproduction in terms.",
      "Differentiate asexual from sexual reproduction in terms.",
      "Describe the process of fertilization.",
      "Describe the process of fertilization.",
      "Differentiate biotic from abiotic components of an ecosystem.",
      "Differentiate biotic from abiotic components of an ecosystem.",
      "Describe the different ecological relationships found in an ecosystem.",
      "Describe the different ecological relationships found in an ecosystem.",
      "Predict the effect of changes in one population on other populations in the ecosystem.",
      "Predict the effect of changes in one population on other populations in the ecosystem.",
      "Predict the effect of changes in abiotic factors on the ecosystem.",
      "Predict the effect of changes in abiotic factors on the ecosystem.",
      "Describe the motion of an object in terms of distance or displacement, speed or velocity, and acceleration.",
      "Describe the motion of an object in terms of distance or displacement, speed or velocity, and acceleration.",
      "Differentiate quantities in terms of magnitude and direction.",
      "Differentiate quantities in terms of magnitude and direction.",
      "Create and interpret visual representation of the motion of objects such as tape charts and motion graphs.",
      "Create and interpret visual representation of the motion of objects such as tape charts and motion graphs.",
      "Infer that waves carry energy.",
      "Infer that waves carry energy.",
      "Differentiate transverse from longitudinal waves, and mechanical from electromagnetic waves.",
      "Differentiate transverse from longitudinal waves, and mechanical from electromagnetic waves.",
      "Relate the characteristics of waves.",
      "Describe the characteristics of sound using the concepts of wavelength, velocity, and amplitude.",
      "Describe the characteristics of sound using the concepts of wavelength, velocity, and amplitude.",
      "Explain sound production in the human voice box, and how pitch, loudness, and quality of sound vary from one person to another.",
      "Describe how organisms produce, transmit, and receive sound of various frequencies (infrasonic, audible, and ultrasonic sound).",
      "Describe how organisms produce, transmit, and receive sound of various frequencies (infrasonic, audible, and ultrasonic sound).",
      "Relate characteristics of light such as color and intensity to frequency and wavelength.",
      "Relate characteristics of light such as color and intensity to frequency and wavelength.",
      "Infer that light travels in a straight line.",
      "Infer that light travels in a straight line.",
      "Infer the conditions necessary for heat transfer to occur.",
      "Infer the conditions necessary for heat transfer to occur.",
      "Describe the different types of charging processes.",
      "Describe the different types of charging processes.",
      "Explain the importance of earthing or grounding.",
      "Explain the importance of earthing or grounding.",
      "Recognize that soil, water, rocks, coal, and other fossil fuels are Earth materials that people use as resources.",
      "Discuss how energy from the Sun interacts with the layers of the atmosphere.",
      "Discuss how energy from the Sun interacts with the layers of the atmosphere.",
      "Account for the occurrence of land and sea breezes, monsoons, and intertropical convergence zone (ITCZ).",
      "Account for the occurrence of land and sea breezes, monsoons, and intertropical convergence zone (ITCZ).",
      "Describe the effects of certain weather systems in the Philippines."
   ])
};

export const ENGLISH8_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "readingcomprehension",
         label: "Reading Comprehension",
         start: 1,
         count: 13,
         mean: 11,
         stdDev: 2.45,
         ranges: [[0,6.29,"Beginner"],[6.3,8.41,"Basic"],[8.42,13,"Competent"]]
      },
      {
         key: "viewingcomprehension",
         label: "Viewing Comprehension",
         start: 14,
         count: 3,
         mean: 1.25,
         stdDev: 0.96,
         ranges: [[0,0.76,"Beginner"],[0.77,2.21,"Basic"],[2.22,3,"Competent"]]
      },
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 17,
         count: 19,
         mean: 10,
         stdDev: 4.97,
         ranges: [[0,7.51,"Beginner"],[7.52,14.97,"Basic"],[14.98,19,"Competent"]]
      },
      {
         key: "literature",
         label: "Literature",
         start: 36,
         count: 9,
         mean: 4.5,
         stdDev: 2.08,
         ranges: [[0,3.45,"Beginner"],[3.46,6.58,"Basic"],[6.59,9,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar Awareness",
         start: 45,
         count: 16,
         mean: 11,
         stdDev: 2.45,
         ranges: [[0,9.77,"Beginner"],[9.78,13.45,"Basic"],[13.46,16,"Competent"]]
      }
   ],
   totalRanges: [[0,25.8,"Beginner"],[25.81,40.56,"Basic"],[40.57,60,"Competent"]],
   totalSummary: {
      count: 60,
      mean: 30.75,
      stdDev: 9.81
   },
   sections: [
      {
         label: "Reading Comprehension",
         start: 1,
         end: 13
      },
      {
         label: "Viewing Comprehension",
         start: 14,
         end: 16
      },
      {
         label: "Vocabulary",
         start: 17,
         end: 35
      },
      {
         label: "Literature",
         start: 36,
         end: 44
      },
      {
         label: "Grammar Awareness",
         start: 45,
         end: 60
      }
   ],
   competencies: toCompetencies([
      "Read intensively to determine the author’s purpose.",
      "Differentiate facts from opinions.",
      "Differentiate facts from opinions.",
      "Differentiate facts from opinions.",
      "Evaluate the details that support assertions in a text.",
      "Examine biases (for or against) made by the author.",
      "Identify positions of a topic sentence.",
      "Identify positions of a topic sentence.",
      "Identify details that support the topic sentence.",
      "Distinguish between general and specific statements.",
      "Distinguish between general and specific statements.",
      "Distinguish between general and specific statements.",
      "Distinguish between general and specific statements.",
      "Determine the issue and stand presented in the material viewed.",
      "Judge the relevance and worth of ideas presented in the material viewed.",
      "Analyze the elements that make up reality and fantasy based on a material viewed.",
      "Determine the meaning of idiomatic expressions by noting context clues and collocations.",
      "Determine the meaning of idiomatic expressions by noting context clues and collocations.",
      "Determine the meaning of idiomatic expressions by noting context clues and collocations.",
      "Distinguish between and among verbal, situational, and dramatic types of irony and give examples of each.",
      "Distinguish between and among verbal, situational, and dramatic types of irony and give examples of each.",
      "Distinguish between and among verbal, situational, and dramatic types of irony and give examples of each.",
      "Discriminate between literal and figurative language.",
      "Discriminate between literal and figurative language.",
      "Identify figures of speech that show emphasis (hyperbole and litotes).",
      "Identify figures of speech that show emphasis (hyperbole and litotes).",
      "Identify figures of speech that show emphasis (hyperbole and litotes).",
      "Identify figures of speech that show emphasis (hyperbole and litotes).",
      "Explain the meaning of a word through structural analysis (prefixes, roots, suffixes).",
      "Explain the meaning of a word through structural analysis (prefixes, roots, suffixes).",
      "Explain the meaning of a word through structural analysis (prefixes, roots, suffixes).",
      "Arrive at meanings through context clues.",
      "Arrive at meanings through context clues.",
      "Arrive at meanings through context clues.",
      "Arrive at meanings through context clues.",
      "Explain the literary devices used.",
      "Determine tone, mood, technique, and purpose of the author.",
      "Determine tone, mood, technique, and purpose of the author.",
      "Use conventions in citing sources.",
      "Use conventions in citing sources.",
      "Identify features of journalistic writing.",
      "Identify features of journalistic writing.",
      "Distinguish among types of journalistic writing (news report, opinion article, feature article, and sports news article).",
      "Distinguish among types of journalistic writing (news report, opinion article, feature article, and sports news article).",
      "Share ideas using opinion-marking signals.",
      "Use modals appropriately.",
      "Use modals appropriately.",
      "Use modals appropriately.",
      "Use modals appropriately.",
      "Use modals appropriately.",
      "Use modals appropriately.",
      "Use modals appropriately.",
      "Use modals appropriately.",
      "Use active and passive constructions in journalistic contexts.",
      "Use active and passive constructions in journalistic contexts.",
      "Use past and past perfect tenses in journalistic writing.",
      "Use past and past perfect tenses in journalistic writing.",
      "Use past and past perfect tenses in journalistic writing.",
      "Use past and past perfect tenses in journalistic writing.",
      "Use past and past perfect tenses in journalistic writing."
   ])
};

export const MATH8_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "algebra",
         label: "Patterns And Algebra",
         start: 1,
         count: 37,
         mean: 19.5,
         stdDev: 1.91,
         ranges: [[0,18.5,"Beginner"],[18.51,21.4,"Basic"],[21.41,37,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 38,
         count: 12,
         mean: 5.75,
         stdDev: 1.5,
         ranges: [[0,4.99,"Beginner"],[5,7.25,"Basic"],[7.26,12,"Competent"]]
      },
      {
         key: "statistics",
         label: "Statistics And Probability",
         start: 50,
         count: 6,
         mean: 3.5,
         stdDev: 0.58,
         ranges: [[0,3.2,"Beginner"],[3.21,4.08,"Basic"],[4.09,6,"Competent"]]
      }
   ],
   totalRanges: [[0,25,"Beginner"],[25.01,30.21,"Basic"],[30.22,55,"Competent"]],
   totalSummary: {
      count: 55,
      mean: 26.75,
      stdDev: 3.4
   },
   sections: [
      {
         label: "Patterns And Algebra",
         start: 1,
         end: 37
      },
      {
         label: "Geometry",
         start: 38,
         end: 49
      },
      {
         label: "Statistics And Probability",
         start: 50,
         end: 55
      }
   ],
   competencies: toCompetencies([
      "Factors completely different types of polynomials.",
      "Factors completely different types of polynomials.",
      "Solves problems involving factors of polynomials.",
      "Solves problems involving factors of polynomials.",
      "Simplifies rational algebraic expressions.",
      "Simplifies rational algebraic expressions.",
      "Performs operations on rational algebraic expressions.",
      "Performs operations on rational algebraic expressions.",
      "Solves problems involving rational algebraic expressions.",
      "Solves problems involving rational algebraic expressions.",
      "Finds the slope of a line given two points, equation, and graph.",
      "Finds the slope of a line given two points, equation, and graph.",
      "Writes the linear equation ax + by = c in the form y + mx = b and vice versa",
      "Writes the linear equation ax + by = c in the form y + mx = b and vice versa",
      "Finds the equation of a line given (a) two points; (b) the slope and a point; (c) the slope and its intercepts.",
      "Finds the equation of a line given (a) two points; (b) the slope and a point; (c) the slope and its intercepts.",
      "Solves problems involving linear equations in two variables.",
      "Solves problems involving linear equations in two variables.",
      "Categorizes when a given system of linear equations in two variables has graphs that are parallel, intersecting, and coinciding.",
      "Categorizes when a given system of linear equations in two variables has graphs that are parallel, intersecting, and coinciding.",
      "Solves problems involving systems of linear equations in two variables.",
      "Solves problems involving systems of linear equations in two variables.",
      "Differentiates linear inequalities in two variables from linear equations in two variables.",
      "Differentiates linear inequalities in two variables from linear equations in two variables.",
      "Solves problems involving linear inequalities in two variables.",
      "Solves problems involving linear inequalities in two variables.",
      "Solves a system of linear inequalities in two variables.",
      "Solves a system of linear inequalities in two variables.",
      "Solves problems involving systems of linear inequalities in two variables.",
      "Verifies if a given relation is a function.",
      "Verifies if a given relation is a function.",
      "Determines dependent and independent variables.",
      "Determines dependent and independent variables.",
      "Finds the domain and range of a function.",
      "Finds the domain and range of a function.",
      "Solves problems involving linear functions.",
      "Solves problems involving linear functions.",
      "Transforms a statement into an equivalent if-then statement.",
      "Transforms a statement into an equivalent if-then statement.",
      "Determines the inverse, converse, and contrapositive of an if-then statement.",
      "Determines the inverse, converse, and contrapositive of an if-then statement.",
      "Applies theorems on triangle inequalities.",
      "Applies theorems on triangle inequalities.",
      "Proves inequalities in a triangle.",
      "Proves inequalities in a triangle.",
      "Proves properties of parallel lines cut by a transversal.",
      "Counts the number of occurrences of an outcome in an experiment: (a) table; (b) tree diagram; (c) systematic listing; and (d) fundamental counting principle.",
      "Counts the number of occurrences of an outcome in an experiment: (a) table; (b) tree diagram; (c) systematic listing; and (d) fundamental counting principle.",
      "Finds the probability of a simple event.",
      "Finds the probability of a simple event.",
      "Finds the probability of a simple event.",
      "Finds the probability of a simple event.",
      "Finds the probability of a simple event.",
      "Solves problems involving probabilities of simple events.",
      "Solves problems involving probabilities of simple events."
   ])
};

export const SCIENCE8_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 1,
         count: 27,
         mean: 15.75,
         stdDev: 3.69,
         ranges: [[0,13.9,"Beginner"],[13.91,19.4,"Basic"],[19.41,27,"Competent"]]
      },
      {
         key: "matter",
         label: "Earth And Space",
         start: 28,
         count: 3,
         mean: 3.5,
         stdDev: 1.29,
         ranges: [[0,2.85,"Beginner"],[2.86,4.79,"Basic"],[4.8,6,"Competent"]]
      },
      {
         key: "matter",
         label: "Matter",
         start: 31,
         count: 6,
         mean: 3.5,
         stdDev: 1.29,
         ranges: [[0,2.85,"Beginner"],[2.86,4.79,"Basic"],[4.8,6,"Competent"]]
      },
      {
         key: "livingthings",
         label: "Living Things",
         start: 37,
         count: 19,
         mean: 10,
         stdDev: 1.2,
         ranges: [[0,9.39,"Beginner"],[9.4,11.2,"Basic"],[11.21,19,"Competent"]]
      },
      {
         key: "earthandspace",
         label: "Earth And Space2",
         start: 56,
         count: 10,
         mean: 8,
         stdDev: 2.58,
         ranges: [[0,6.7,"Beginner"],[6.71,10.6,"Basic"],[10.61,13,"Competent"]]
      }
   ],
   totalRanges: [[0,27.9,"Beginner"],[27.91,38,"Basic"],[38.01,65,"Competent"]],
   totalSummary: {
      count: 65,
      mean: 31.25,
      stdDev: 6.75
   },
   sections: [
      {
         label: "Force And Motion",
         start: 1,
         end: 27
      },
      {
         label: "Earth And Space",
         start: 28,
         end: 30
      },
      {
         label: "Matter",
         start: 31,
         end: 36
      },
      {
         label: "Living Things",
         start: 37,
         end: 55
      },
      {
         label: "Earth And Space2",
         start: 56,
         end: 65
      }
   ],
   competencies: toCompetencies([
      "Investigate the relationship between the amount of force applied and the mass of the object to the amount of force applied and the mass of the object to the amount of force applied and the mass of the object to the amount of change in the objects motion.",
      "Investigate the relationship between the amount of force applied and the mass of the object to the amount of force applied and the mass of the object to the amount of force applied and the mass of the object to the amount of change in the objects motion.",
      "Infer that when a body exerts a force on another an equal amount of force is exerted back on it.",
      "Infer that when a body exerts a force on another an equal amount of force is exerted back on it.",
      "Demonstrate how a body responds to changes in motion.",
      "Demonstrate how a body responds to changes in motion.",
      "Relate the laws of motion to bodies in uniform circular motion.",
      "Relate the laws of motion to bodies in uniform circular motion.",
      "Infer the circular motion requires the application of constant force directed toward the center of the circle.",
      "Describe how work is related to power and energy.",
      "Relate speed and position of object to the amount of energy possessed by a body.",
      "Infer how the movement of particles of an object affects the speed of sound.",
      "Infer how the movement of particles of an object affects the speed of sound.",
      "Investigate the effect of temperature to speed of sound through fair testing.",
      "Investigate the effect of temperature to speed of sound through fair testing.",
      "Demonstrate the existence of the color components of visible light using a prism or diffraction grating.",
      "Explain the hierarchy of colors in relation to energy.",
      "Explain the hierarchy of colors in relation to energy.",
      "Differentiate between heat and temperature at the molecular level.",
      "Differentiate between heat and temperature at the molecular level.",
      "Infer the relationship between current and charge.",
      "Explain the advantages and disadvantages of series and parallel connections in homes.",
      "Explain the advantages and disadvantages of series and parallel connections in homes.",
      "Differentiate electrical power and electrical energy.",
      "Differentiate electrical power and electrical energy.",
      "Explain the function of circuit breakers, fuses, earthing, double insulation, and other safety devices in the home.",
      "Explain the function of circuit breakers, fuses, earthing, double insulation, and other safety devices in the home.",
      "Using models or illustrations, explain how movements along faults generate earthquakes.",
      "Using models or illustrations, explain how movements along faults generate earthquakes.",
      "Explain the properties of solids, liquids, and gases based on the particle nature of matter.",
      "Explain physical changes in terms of the arrangement and motion of atoms and molecules.",
      "Explain physical changes in terms of the arrangement and motion of atoms and molecules.",
      "Determine the number of protons, neutrons, and electrons in a particular atom.",
      "Trace the development of the periodic table from observations based on similarities in properties of elements.",
      "Use the periodic table to predict the chemical behaviour of an element.",
      "Use the periodic table to predict the chemical behaviour of an element.",
      "Explain ingestion, absorption, assimilation, and excretion.",
      "Explain ingestion, absorption, assimilation, and excretion.",
      "Explain how diseases of the digestive system are prevented, detected, and treated.",
      "Explain how diseases of the digestive system are prevented, detected, and treated.",
      "Healthful practices that affect the digestive system.",
      "Healthful practices that affect the digestive system.",
      "Compare mitosis and meiosis, and their role in the cell-division cycle.",
      "Compare mitosis and meiosis, and their role in the cell-division cycle.",
      "Explain the significance of meiosis in maintaining the chromosome number.",
      "Describe the transfer of energy through the trophic levels.",
      "Analyze the roles of organisms in the cycling of materials.",
      "Explain how materials cycle in an ecosystem.",
      "Explain how materials cycle in an ecosystem.",
      "Suggest ways to minimize human impact on the environment.",
      "Suggest ways to minimize human impact on the environment.",
      "Explain the concept of a species.",
      "Predict penotypic expressions of traits following simple patterns of inheritance.",
      "Predict penotypic expressions of traits following simple patterns of inheritance.",
      "Explain the advantage of high biodiversity in maintaining the stability of an ecosystem.",
      "Demonstrate how underwater earthquakes generate tsunamis.",
      "Demonstrate how underwater earthquakes generate tsunamis.",
      "Explain how earthquake waves provide information about the interior of the earth.",
      "Explain how earthquake waves provide information about the interior of the earth.",
      "Explain how typhoons develop.",
      "Explain how typhoons develop.",
      "Infer why the Philippines is prone to typhoons.",
      "Explain how landmasses and bodies of water affect typhoons.",
      "Explain how landmasses and bodies of water affect typhoons.",
      "Compare and contrast comets, meteors, and asteroids."
   ])
};

export const ENGLISH9_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "readingomprehension",
         label: "Reading Comprehension",
         start: 1,
         count: 4,
         mean: 1.75,
         stdDev: 0.5,
         ranges: [[0,1.49,"Beginner"],[1.5,2.25,"Basic"],[2.26,4,"Competent"]]
      },
      {
         key: "viewingomprehension",
         label: "Viewing Comprehension",
         start: 5,
         count: 5,
         mean: 3.75,
         stdDev: 0.5,
         ranges: [[0,3.49,"Beginner"],[3.5,4.25,"Basic"],[4.26,5,"Competent"]]
      },
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 10,
         count: 11,
         mean: 7,
         stdDev: 2.83,
         ranges: [[0,5.58,"Beginner"],[5.59,9.83,"Basic"],[9.84,11,"Competent"]]
      },
      {
         key: "literature",
         label: "Literature",
         start: 21,
         count: 4,
         mean: 2.2,
         stdDev: 1.41,
         ranges: [[0,1.49,"Beginner"],[1.5,3.61,"Basic"],[3.62,4,"Competent"]]
      },
      {
         key: "writing",
         label: "Writing and Composition",
         start: 25,
         count: 4,
         mean: 1.5,
         stdDev: 1,
         ranges: [[0,0.99,"Beginner"],[1,2.5,"Basic"],[2.51,4,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar Awareness",
         start: 29,
         count: 22,
         mean: 15,
         stdDev: 3.37,
         ranges: [[0,13.3,"Beginner"],[13.31,18.4,"Basic"],[18.41,22,"Competent"]]
      }
   ],
   totalRanges: [[0,24.6,"Beginner"],[24.61,33.3,"Basic"],[33.31,50,"Competent"]],
   totalSummary: {
      count: 58,
      mean: 27.5,
      stdDev: 5.8
   },
   sections: [
      {
         label: "Reading Comprehension",
         start: 1,
         end: 4
      },
      {
         label: "Viewing Comprehension",
         start: 5,
         end: 17
      },
      {
         label: "Vocabulary",
         start: 10,
         end: 20
      },
      {
         label: "Literature",
         start: 21,
         end: 24
      },
      {
         label: "Writing and Composition",
         start: 25,
         end: 28
      },
      {
         label: "Grammar Awareness",
         start: 29,
         end: 50
      }
   ],
   competencies: toCompetencies([
      "Explain the literary devices used.",
      "Determine tone, mood, technique, and purpose of the author.",
      "Relate text content to particular social issues, concerns, or dispositions in real life.",
      "Judge the relevance and worth of ideas, soundness of author’s reasoning, and the effectiveness of the presentation.",
      "Infer thoughts, feelings, and intentions in the material viewed.",
      "Assess the relevance and worth of ideas presented in the material viewed.",
      "Draw generalizations and conclusions from the material viewed.",
      "Interpret the message conveyed in a material viewed.",
      "Formulate predictions based on the material viewed.",
      "Provide words or expressions appropriate for a given situation.",
      "Provide words or expressions appropriate for a given situation.",
      "Explain how words are derived from names of persons and places.",
      "Arrive at meaning of words through word formation (clipping, blending, acronymy, compounding, folk etymology, etc.).",
      "Note types of context clue (restatement, definition, synonyms, antonyms) used for a given word or expression.",
      "Note types of context clue (restatement, definition, synonyms, antonyms) used for a given word or expression.",
      "Note types of context clue (restatement, definition, synonyms, antonyms) used for a given word or expression.",
      "Give the appropriate communicative styles for various situations (intimate, casual, conversational, consultative, frozen).",
      "Give the appropriate communicative styles for various situations (intimate, casual, conversational, consultative, frozen).",
      "Give the appropriate communicative styles for various situations (intimate, casual, conversational, consultative, frozen).",
      "Determine the vocabulary or jargons expected of a communicative style.",
      "Determine tone, mood, technique, and purpose of the author.",
      "Determine tone, mood, technique, and purpose of the author.",
      "Determine tone, mood, technique, and purpose of the author.",
      "Explain the literary devices used.",
      "Distinguish between and among informative, journalistic, and literary writing.",
      "Identify types and features of poetry.",
      "Distinguish the features present in poetry and in prose.",
      "Distinguish the features present in poetry and in prose.",
      "Use appropriate punctuation marks and capitalization to convey meaning.",
      "Use appropriate punctuation marks and capitalization to convey meaning.",
      "Use appropriate punctuation marks and capitalization to convey meaning.",
      "Use interjections to convey meaning.",
      "Use interjections to convey meaning.",
      "Use interjections to convey meaning.",
      "Use interjections to convey meaning.",
      "Use adverbs in narration.",
      "Use adverbs in narration.",
      "Use conditionals in expressing arguments.",
      "Use conditionals in expressing arguments.",
      "Use past conditionals in expressing arguments.",
      "Use past conditionals in expressing arguments.",
      "Use past conditionals in expressing arguments.",
      "Use verbals.",
      "Use verbals.",
      "Use verbals.",
      "Use active and passive constructions.",
      "Use active and passive constructions.",
      "Express permission, obligation, and prohibition.",
      "Express permission, obligation, and prohibition.",
      "Change direct to indirect speech and vice versa."
   ])
};

export const MATH9_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "algebra",
         label: "Patterns And Algebra",
         start: 1,
         count: 34,
         mean: 18,
         stdDev: 2.16,
         ranges: [[0,16.9,"Beginner"],[16.91,20.2,"Basic"],[20.21,34,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 36,
         count: 26,
         mean: 10.5,
         stdDev: 2.38,
         ranges: [[0,9.3,"Beginner"],[9.31,12.9,"Basic"],[12.91,26,"Competent"]]
      }
   ],
   totalRanges: [[0,28.5,"Beginner"],[28.51,31.6,"Basic"],[31.61,60,"Competent"]],
   totalSummary: {
      count: 60,
      mean: 29.5,
      stdDev: 2.08
   },
   sections: [
      {
         label: "Patterns And Algebra",
         start: 1,
         end: 34
      },
      {
         label: "Geometry",
         start: 36,
         end: 60
      }
   ],
   competencies: toCompetencies([
      "Illustrates quadratic equations.",
      "Illustrates quadratic equations.",
      "Solves quadratic equations.",
      "Solves quadratic equations.",
      "Characterizes the roots of a quadratic equation using the discriminant.",
      "Characterizes the roots of a quadratic equation using the discriminant.",
      "Describes the relationship between the coefficients and the roots of a quadratic equation.",
      "Describes the relationship between the coefficients and the roots of a quadratic equation.",
      "Solves equations transformable to quadratic equations (including rational algebraic equations).",
      "Solves equations transformable to quadratic equations (including rational algebraic equations).",
      "Solves problems involving quadratic equations and rational algebraic equations.",
      "Solves problems involving quadratic equations and rational algebraic equations.",
      "Solves quadratic inequalities.",
      "Solves quadratic inequalities.",
      "Solves problems involving quadratic inequalities.",
      "Solves problems involving quadratic inequalities.",
      "Represents a quadratic function.",
      "Represents a quadratic function.",
      "Transforms the quadratic function defined by y = ax2 + bx + c into the form y = a(x – h)2 + k.",
      "Transforms the quadratic function defined by y = ax2 + bx + c into the form y = a(x – h)2 + k.",
      "Determines the equation of a quadratic function given: (a) a table of values; (b) graph; (c) zeros.",
      "Determines the equation of a quadratic function.",
      "Solves problems involving quadratic functions.",
      "Solves problems involving quadratic functions.",
      "Illustrates situations that involve the following variations: (a) direct; (b) inverse; (c) joint; (d) combined.",
      "Illustrates situations that involve the following variations: (a) direct; (b) inverse; (c) joint; (d) combined.",
      "Illustrates expressions with rational exponents.",
      "Illustrates expressions with rational exponents.",
      "Illustrates expressions with rational exponents.",
      "Illustrates expressions with rational exponents.",
      "Simplifies radical expressions using the laws of radicals.",
      "Simplifies radical expressions using the laws of radicals.",
      "Solves problems involving radicals.",
      "Solves problems involving radicals.",
      "Identifies quadrilaterals that are parallelograms.",
      "Identifies quadrilaterals that are parallelograms.",
      "Determines the conditions that guarantee a quadrilateral a parallelogram.",
      "Determines the conditions that guarantee a quadrilateral a parallelogram.",
      "Uses properties to find measures of angles, sides and other quantities involving parallelograms.",
      "Uses properties to find measures of angles, sides and other quantities involving parallelograms.",
      "Uses properties to find measures of angles, sides and other quantities involving parallelograms.",
      "Uses properties to find measures of angles, sides and other quantities involving parallelograms.",
      "Uses properties to find measures of angles, sides and other quantities involving parallelograms.",
      "Uses properties to find measures of angles, sides and other quantities involving parallelograms.",
      "Illustrates similarity of figures.",
      "Illustrates similarity of figures.",
      "Applies the theorems to show that given triangles are similar.",
      "Applies the theorems to show that given triangles are similar.",
      "Illustrates the six trigonometric ratios: sine, cosine, tangent, secant, cosecant, and cotangent.",
      "Illustrates the six trigonometric ratios: sine, cosine, tangent, secant, cosecant, and cotangent.",
      "Finds the trigonometric ratios of special angles.",
      "Finds the trigonometric ratios of special angles.",
      "Illustrates angles of elevation and angles of depression.",
      "Illustrates angles of elevation and angles of depression.",
      "Illustrates laws of sines and cosines.",
      "Illustrates laws of sines and cosines.",
      "Solves problems involving oblique triangles.",
      "Solves problems involving oblique triangles.",
      "Graphs a quadratic function.",
      "Graphs a quadratic function."
   ])
};

export const SCIENCE9_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "livingthings",
         label: "Living Things",
         start: 1,
         count: 11,
         mean: 5,
         stdDev: 2.16,
         ranges: [[0,3.91,"Beginner"],[3.92,7.16,"Basic"],[7.17,11,"Competent"]]
      },
      {
         key: "matter",
         label: "Matter",
         start: 12,
         count: 15,
         mean: 9.5,
         stdDev: 1.29,
         ranges: [[0,8.7,"Beginner"],[8.71,11.1,"Basic"],[11.11,15,"Competent"]]
      },
      {
         key: "earthandspace",
         label: "Earth and Space",
         start: 27,
         count: 15,
         mean: 9.25,
         stdDev: 1.71,
         ranges: [[0,8.39,"Beginner"],[8.4,10.96,"Basic"],[10.97,15,"Competent"]]
      },
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 42,
         count: 19,
         mean: 7,
         stdDev: 1.41,
         ranges: [[0,6.29,"Beginner"],[6.3,8.41,"Basic"],[8.42,19,"Competent"]]
      }
   ],
   totalRanges: [[0,27.4,"Beginner"],[27.41,33.6,"Basic"],[33.61,60,"Competent"]],
   totalSummary: {
      count: 60,
      mean: 29.5,
      stdDev: 4.11
   },
   sections: [
      {
         label: "Living Things",
         start: 1,
         end: 11
      },
      {
         label: "Matter",
         start: 12,
         end: 26
      },
      {
         label: "Earth and Space",
         start: 27,
         end: 41
      },
      {
         label: "Force And Motion",
         start: 42,
         end: 60
      }
   ],
   competencies: toCompetencies([
      "Explain how the respiratory and circulatory systems work together to transport nutrients, gases, and other molecules to and from the different parts of the body.",
      "Explain how the respiratory and circulatory systems work together to transport nutrients, gases, and other molecules to and from the different parts of the body.",
      "Infer how one’s lifestyle can affect the functioning of respiratory and circulatory systems.",
      "Infer how one’s lifestyle can affect the functioning of respiratory and circulatory systems.",
      "Describe the location of genes in chromosomes.",
      "Describe the location of genes in chromosomes.",
      "Explain the different patterns of non-Mendelian inheritance.",
      "Explain the different patterns of non-Mendelian inheritance.",
      "Relate species extinction to the failure of populations of organisms to adapt to abrupt changes in the environment.",
      "Differentiate basic features and importance of photosynthesis and respiration.",
      "Differentiate basic features and importance of photosynthesis and respiration.",
      "Explain the formation of ionic and covalent bonds.",
      "Explain the formation of ionic and covalent bonds.",
      "Recognize different types of compounds (ionic or covalent) based on their properties such as melting point, hardness, polarity, and electrical and thermal conductivity.",
      "Recognize different types of compounds (ionic or covalent) based on their properties such as melting point, hardness, polarity, and electrical and thermal conductivity.",
      "Explain properties of metals in terms of their structure.",
      "Explain properties of metals in terms of their structure.",
      "Explain how ions are formed.",
      "Explain how ions are formed.",
      "Explain how the structure of the carbon atom affects the type of bonds it forms.",
      "Recognize the general classes and uses of organic compounds.",
      "Recognize the general classes and uses of organic compounds.",
      "Use the mole concept to express mass of substances.",
      "Use the mole concept to express mass of substances.",
      "Determine the percentage composition of a compound given its chemical formula and vice-versa.",
      "Determine the percentage composition of a compound given its chemical formula and vice-versa.",
      "Describe the different types of volcanoes.",
      "Describe the different types of volcanoes.",
      "Differentiate between active and inactive volcanoes.",
      "Differentiate between active and inactive volcanoes.",
      "Explain what happens when volcanoes erupt.",
      "Explain what happens when volcanoes erupt.",
      "Illustrate how energy from volcanoes may be tapped from human use.",
      "Illustrate how energy from volcanoes may be tapped from human use.",
      "Explain how different factors affect the climate of an area.",
      "Explain how different factors affect the climate of an area.",
      "Infer the characteristics of stars based on the characteristics of the sun.",
      "Infer the characteristics of stars based on the characteristics of the sun.",
      "Infer that the arrangement of stars in a group (constellation) does not change.",
      "Infer that the arrangement of stars in a group (constellation) does not change.",
      "Observe the position of a constellation changes in the course of the night.",
      "Describe the horizontal and vertical motions of a projectile.",
      "Describe the horizontal and vertical motions of a projectile.",
      "Investigate the relationship between the angle of release and the height and range of the projectile.",
      "Investigate the relationship between the angle of release and the height and range of the projectile.",
      "Relate impulse and momentum to collision of object.",
      "Relate impulse and momentum to collision of object.",
      "Infer that the total momentum before and after collision is equal.",
      "Infer that the total momentum before and after collision is equal.",
      "Examine effects and predict causes of collision-related damages/injuries.",
      "Explain energy transformation in various activities/events.",
      "Perform activities to demonstrate conservation of mechanical energy.",
      "Perform activities to demonstrate conservation of mechanical energy.",
      "Infer that the total mechanical energy remains the same during any process.",
      "Infer that the total mechanical energy remains the same during any process.",
      "Construct a model to demonstrate that heat can do work.",
      "Construct a model to demonstrate that heat can do work.",
      "Infer that heat transfer can be used to do work, and that work involves the release of heat.",
      "Infer that heat transfer can be used to do work, and that work involves the release of heat.",
      "Explain how heat transfer and energy transformation make heat engines like geothermal plants work."
   ])
};

export const ENGLISH10_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "readingomprehension",
         label: "Reading Comprehension",
         start: 1,
         count: 17,
         mean: 11.73,
         stdDev: 2.09,
         ranges: [[0,10.99,"Beginner"],[11,12,"Basic"],[12.01,14,"Competent"]]
      },
      {
         key: "viewingomprehension",
         label: "Viewing Comprehension",
         start: 18,
         count: 4,
         mean: 2.9,
         stdDev: 0.82,
         ranges: [[0,1.99,"Beginner"],[2,3,"Basic"],[3.01,4,"Competent"]]
      },
      {
         key: "vocabulary",
         label: "Vocabulary",
         start: 22,
         count: 7,
         mean: 3.47,
         stdDev: 0.77,
         ranges: [[0,1.99,"Beginner"],[2,3,"Basic"],[3.01,7,"Competent"]]
      },
      {
         key: "writing",
         label: "Writing and Composition",
         start: 29,
         count: 4,
         mean: 2.88,
         stdDev: 1.36,
         ranges: [[0,1.99,"Beginner"],[2,3,"Basic"],[3.01,4,"Competent"]]
      },
      {
         key: "grammar",
         label: "Grammar",
         start: 33,
         count: 8,
         mean: 6.26,
         stdDev: 1.19,
         ranges: [[0,4.99,"Beginner"],[5,6,"Basic"],[6.01,8,"Competent"]]
      }
   ],
   totalRanges: [[0,25.99,"Beginner"],[26,28,"Basic"],[28.01,40,"Competent"]],
   totalSummary: {
      count: 40,
      mean: 27.26,
      stdDev: 3.9
   },
   sections: [
      {
         label: "Reading Comprehension",
         start: 1,
         end: 17
      },
      {
         label: "Viewing Comprehension",
         start: 18,
         end: 21
      },
      {
         label: "Vocabulary",
         start: 22,
         end: 28
      },
      {
         label: "Writing and Composition",
         start: 29,
         end: 32
      },
      {
         label: "Grammar",
         start: 33,
         end: 40
      }
   ],
   competencies: toCompetencies([
      "Read closely to get the author’s purpose.",
      "Read closely to get explicitly and implicitly stated information.",
      "Read closely to get explicitly and implicitly stated information.",
      "Identifying textual details that affirm or refute a claim.",
      "Identifying textual details that affirm or refute a claim.",
      "Draw conclusions from the set of details.",
      "Draw conclusions from the set of details.",
      "Identify power struggles of characters (Marxist).",
      "Examine Biases.",
      "Relevance of the selection to the historical context during which it was produced (historical).",
      "Distinguish facts from beliefs (fact).",
      "Distinguish facts from beliefs (belief).",
      "Point out relationships among statements.",
      "Point out relationships among statements.",
      "Distinguish between general and specific statements.",
      "Distinguish between general and specific statements.",
      "Distinguish between general and specific statements.",
      "Determine the relevance and the truthfulness of the ideas presented in the material viewed.",
      "Formulate predictions based on the material viewed.",
      "Draw generalizations and conclusions based on the materials viewed.",
      "Detect bias and prejudice in the material viewed.",
      "Differentiate formal from informal definitions of words.",
      "Give technical and operational definitions (technical).",
      "Give technical and operational definitions (operational).",
      "Give expanded definitions of words.",
      "Give expanded definitions of words.",
      "Get familiar with technical terms used in research.",
      "Get familiar with technical terms used in research.",
      "Identify features of persuasive texts.",
      "Identify parts and features of argumentative essays.",
      "Formulate claims of fact, policy, and value.",
      "Acknowledge sources by preparing a bibliography.",
      "Use reflexive and intensive pronouns.",
      "Use reflexive and intensive pronouns.",
      "Use modals",
      "Use modals",
      "Use modals",
      "Observe correct grammar in making definitions.",
      "Use words and expressions that affirm or negate.",
      "Use pronouns effectively."
   ])
};

export const MATH10_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "algebra",
         label: "Patterns And Algebra",
         start: 1,
         count: 21,
         mean: 5.47,
         stdDev: 1.62,
         ranges: [[0,16.9,"Beginner"],[16.91,20.2,"Basic"],[20.21,21,"Competent"]]
      },
      {
         key: "geometry",
         label: "Geometry",
         start: 22,
         count: 8,
         mean: 5.47,
         stdDev: 1.62,
         ranges: [[0,4.99,"Beginner"],[5,7.25,"Basic"],[7.26,9,"Competent"]]
      },
      {
         key: "statistics",
         label: "Statistics And Probability",
         start: 31,
         count: 15,
         mean: 8.19,
         stdDev: 2.17,
         ranges: [[0,6.99,"Beginner"],[7,10,"Basic"],[10.01,16,"Competent"]]
      }
   ],
   totalRanges: [[0,25.99,"Beginner"],[26,28,"Basic"],[28.01,45,"Competent"]],
   totalSummary: {
      count: 44,
      mean: 27.52,
      stdDev: 4.47
   },
   sections: [
      {
         label: "Patterns And Algebra",
         start: 1,
         end: 21
      },
      {
         label: "Geometry",
         start: 22,
         end: 29
      },
      {
         label: "Statistics And Probability",
         start: 31,
         end: 45
      }
   ],
   competencies: toCompetencies([
      "Generates patterns.",
      "Determines arithmetic means and nth term of an arithmetic sequence.",
      "Illustrates a geometric sequence.",
      "Differentiates a geometric sequence from an arithmetic sequence.",
      "Differentiates a finite geometric sequence from an infinite geometric sequence.",
      "Determines geometric means and nth term of a geometric sequence.",
      "Finds the sum of the terms of a given finite or infinite geometric sequence.",
      "Solves problems involving sequences.",
      "Performs division of polynomials using long division and synthetic division.",
      "Performs division of polynomials using long division and synthetic division.",
      "Proves the Remainder Theorem and the Factor Theorem.",
      "Factors polynomials.",
      "Factors polynomials.",
      "Factors polynomials.",
      "Proves Rational Root Theorem.",
      "Illustrates polynomial equations (in a graph).",
      "Solves polynomial equations.",
      "Solves polynomial equations.",
      "Solves problems involving polynomials and polynomial equations.",
      "Illustrates polynomial functions (in a graph).",
      "Solves problems involving polynomial functions.",
      "Proves theorems related to chords, arcs, central angles, and inscribed angles.",
      "Illustrates secants, tangents, segments, and sectors of a circle.",
      "Proves theorems on secants, tangents, and segments",
      "Solves problems on circles.",
      "Illustrates secants, tangents, segments, and sectors of a circle.",
      "Proves theorems on secants, tangents, and segments",
      "Determines the center and radius of a circle given its equation and vice versa.",
      "Illustrates the center-radius form of the equation of a circle.",
      "Solves problems involving geometric figures on the coordinate plane.",
      "Illustrates the permutation of objects.",
      "Solves problems involving permutations.",
      "Differentiates permutation from combination of n objects taken r at a time.",
      "Solves problems involving permutations.",
      "Illustrates events, and union and intersection of events.",
      "Solves problems involving permutations and combinations.",
      "Finds the probability of (A U B).",
      "Illustrates the probability of a union of two events.",
      "Solves problems involving probability.",
      "Illustrates independent events.",
      "Calculates a specified measure of position (e.g. 90th percentile) of a set of data.",
      "Illustrates the following measures of position: quartiles, deciles and percentiles.",
      "Solves problems involving measures of position.",
      "Interprets measures of position.",
      "Uses appropriate measures of position and other statistical methods in analyzing and interpreting research data."
   ])
};

export const SCIENCE10_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: "earthandspace",
         label: "Earth and Space",
         start: 1,
         count: 8,
         mean: 4.59,
         stdDev: 1.41,
         ranges: [[0,3.99,"Beginner"],[4,5,"Basic"],[5.01,8,"Competent"]]
      },
      {
         key: "forceandmotion",
         label: "Force And Motion",
         start: 9,
         count: 8,
         mean: 2.81,
         stdDev: 0.99,
         ranges: [[0,1.99,"Beginner"],[2,3,"Basic"],[3.01,8,"Competent"]]
      },
      {
         key: "livingthings",
         label: "Living Things",
         start: 17,
         count: 15,
         mean: 7.38,
         stdDev: 1.82,
         ranges: [[0,5.99,"Beginner"],[6,7,"Basic"],[7.01,15,"Competent"]]
      },
      {
         key: "matter",
         label: "Matter",
         start: 32,
         count: 14,
         mean: 7.52,
         stdDev: 2.63,
         ranges: [[0,5.99,"Beginner"],[6,8,"Basic"],[8.01,14,"Competent"]]
      }
   ],
   totalRanges: [[0,19.99,"Beginner"],[20,23,"Basic"],[23.01,45,"Competent"]],
   totalSummary: {
      count: 45,
      mean: 22.3,
      stdDev: 4.38
   },
   sections: [
      {
         label: "Earth and Space",
         start: 1,
         end: 8
      },
      {
         label: "Force And Motion",
         start: 9,
         end: 16
      },
      {
         label: "Living Things",
         start: 17,
         end: 31
      },
      {
         label: "Matter",
         start: 32,
         end: 45
      }
   ],
   competencies: toCompetencies([
      "Describe the distribution of active volcanoes, earthquake epicenters, and major mountain belts.",
      "Describe the different types of plate boundaries.",
      "Explain the different processes that occur along the plate boundaries.",
      "Describe the internal structure of the Earth.",
      "Describe the internal structure of the Earth.",
      "Describe the possible causes of plate movement.",
      "Enumerate the lines of evidence that support plate movement.",
      "Enumerate the lines of evidence that support plate movement.",
      "Compare the relative wavelengths of different forms of electromagnetic waves.",
      "Cite examples of practical applications of the different regions of EM waves, such as the use of radio waves in telecommunications.",
      "Cite examples of practical applications of the different regions of EM waves, such as the use of radio waves in telecommunications.",
      "Explain the effects of EM radiation on living things and the environment.",
      "Predict the qualitative characteristics (orientation, type, and magnification) of images formed by plane and curved mirrors and lenses.",
      "Apply ray diagramming techniques in describing the characteristics and positions of images formed by lenses.",
      "Identify ways in which the properties of mirrors and lenses determine their use in optical instruments (e.g., cameras and binoculars).",
      "Explain the operation of a simple electric motor and generator.",
      "Describe the parts of the reproductive system and their functions.",
      "Describe the parts of the reproductive system and their functions.",
      "Explain the role of hormones involved in the female and male reproductive systems.",
      "Explain the role of hormones involved in the female and male reproductive systems.",
      "Describe the feedback mechanisms involved in regulating processes in the female reproductive system (e.g., menstrual cycle).",
      "Describe how the nervous system coordinates and regulates these feedback mechanisms to maintain homeostasis.",
      "Explain how protein is made using information from DNA.",
      "Explain how mutations may cause changes in the structure and function of a protein.",
      "Explain how fossil records, comparative anatomy, and genetic information provide evidence for evolution.",
      "Explain the occurrence of evolution.",
      "Explain how species diversity increases the probability of adaptation and survival of organisms in changing environments.",
      "Explain the relationship between population growth and carrying capacity.",
      "Suggest ways to minimize human impact on the environment.",
      "Suggest ways to minimize human impact on the environment.",
      "Suggest ways to minimize human impact on the environment.",
      "Investigate the relationship between:volume and pressure at constant temperature of a gas.",
      "Investigate the relationship between:volume and pressure at constant temperature of a gas.",
      "Investigate the relationship between:volume and pressure at constant temperature of a gas.",
      "Investigate the relationship between: volume and temperature at constant pressure of a gas.",
      "Investigate the relationship between: volume and temperature at constant pressure of a gas.",
      "Investigate the relationship between: volume and temperature at constant pressure of a gas.",
      "Explain the relationship between volume and pressure using the kinetic molecular theory.",
      "Explain the relationship between volume and pressure using the kinetic molecular theory.",
      "Recognize the major categories of biomolecules such as carbohydrates, lipids, proteins, and nucleic acids.",
      "Recognize the major categories of biomolecules such as carbohydrates, lipids, proteins, and nucleic acids.",
      "Apply the principles of conservation of mass to chemical reactions.",
      "Apply the principles of conservation of mass to chemical reactions.",
      "Explain how the factors affecting rates of chemical reactions are applied in food preservation and materials production, control of fire, pollution, and corrosion.",
      "Explain how the factors affecting rates of chemical reactions are applied in food preservation and materials production, control of fire, pollution, and corrosion."
   ])
};
